import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "./switch.css";
import { tokenDecode } from "../../utils/helper";
import { toast } from "react-toastify";
import edit from "../../icons/edit_ui.png";
import Circularprogress from "../../components/Generics/Circularprogress";
import axios from "axios";
import { Link } from "react-router-dom";
import editfull from "../../icons/edit.png";
import ReactPaginate from 'react-paginate';
import styled from "styled-components";
import { config } from "../../utils/config";
import Applyfilter from "../../components/Applyfilter/Applyfilter";
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import "../../index.css"
import ThemeMaker from "../../components/thememaker";
import jwt_decode from "jwt-decode";
import CloseIcon from '@mui/icons-material/Close';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import DeleteIcon from '@mui/icons-material/Delete';
import QRCode from "react-qr-code";
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { toPng } from 'html-to-image';
import DownloadForOfflineRoundedIcon from '@mui/icons-material/DownloadForOfflineRounded';
import styles from "./style.module.css";
import { Modal as AntModal, Spin } from "antd";
import { BsThreeDotsVertical } from "react-icons/bs";
import { BiSolidImageAdd } from "react-icons/bi";
import { FiInfo, FiLayers, FiPackage, FiTruck, FiBox, FiCheckCircle } from "react-icons/fi";

import {
  Dropdown, AutoComplete, Cascader, Checkbox, Col, Form, Input, InputNumber, Row, Select, Space, Tag
} from 'antd';

const { apiEndpoint, baseNodeapiUrl } = config

const modalStyle = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1000, bgcolor: 'background.paper', boxShadow: 24, borderRadius: "10px", p: 1, color: "black",
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const Instorecatalog = (props) => {
  const decoded = tokenDecode();
  const userObj = Array.isArray(decoded?.data?.user) ? decoded?.data?.user[0] : (decoded?.data?.user || {});
  const roleObj = Array.isArray(decoded?.data?.role) ? decoded?.data?.role[0] : (decoded?.data?.role || {});
  let current_sellerid = userObj?.seller_id ?? userObj?.parent_id ?? roleObj?.seller_id;
  const { permission: { product }, } = decoded?.data || { permission: {} };
  const [searchValue, setsearchValue] = useState("");
  const searchTimeoutRef = useRef(null);
  const [openInput, setopenInput] = useState(null);
  const [productlist, setproductlist] = useState([]);
  const [productisLoading, setproductisLoading] = useState(false);
  const [noproducts, setNoproducts] = useState(false);
  const [file, setFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [Alertopen, setAlertOpen] = useState(false);
  const [syncing, setsyncing] = useState(false);
  const [ConfirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [bulkUpdateModalOpen, setBulkUpdateModalOpen] = useState(false);
  const [bulkUpdateFile, setBulkUpdateFile] = useState(null);
  const [isBulkUpdating, setIsBulkUpdating] = useState(false);
  const loadingRequestCount = useRef(0);

  const startLoading = () => {
    loadingRequestCount.current += 1;
    setIsPageLoading(true);
  };

  const stopLoading = () => {
    loadingRequestCount.current = Math.max(0, loadingRequestCount.current - 1);
    setIsPageLoading(loadingRequestCount.current > 0);
  };

  const handleAlertOpen = () => {
    setOpen(false);
    setAlertOpen(true);

  };
  let rawToken = sessionStorage.getItem("token");
  var decode = jwt_decode(rawToken);

  const Syncapi = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(
        `${apiEndpoint}/add-shopify-product`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Sync failed", error);
    }
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
    setsyncingData({
      seller_id: current_sellerid.toString(),
      price: false,
      inventory: false,
      sku: false,
      title: false,
      weight: false
    })
  };

  const [syncingData, setsyncingData] = useState({
    seller_id: current_sellerid,
    price: false,
    inventory: false,
    sku: false,
    title: false,
    weight: false

  })
  const handleSyncModalOpen = () => setOpen(true);
  const [variantsModalOpen, setVariantsModalOpen] = useState(false);
  const [variantsModalLoading, setVariantsModalLoading] = useState(false);
  const [selectedProductVariants, setSelectedProductVariants] = useState([]);
  console.log("sdfghjk", selectedProductVariants)
  const [selectedProductDetails, setSelectedProductDetails] = useState(null);
  const creatvariant = selectedProductVariants[0]?.product_type_id
  // Create & Edit Variation modal state
  const [createVariantModalOpen, setCreateVariantModalOpen] = useState(false);
  const [editingVariantId, setEditingVariantId] = useState(null);
  const [isVariantDetailsLoading, setIsVariantDetailsLoading] = useState(false);
  const [isSubmittingVariant, setIsSubmittingVariant] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [variantWarehouses, setVariantWarehouses] = useState({});
  const [variantWarehouseQty, setVariantWarehouseQty] = useState({});
  const [tempVariantWarehouses, setTempVariantWarehouses] = useState([]);
  const [tempVariantQty, setTempVariantQty] = useState("");
  const [newVariantForm, setNewVariantForm] = useState({
    sku: "",
    warehouse_id: "",
    hsn: "",
    mrp: "",
    selling_price: "",
    quantity: "10",
    uom: "piece",
    uom_value: "1",
    status: true,
    attributes: [{ attribute_name: "Color", attribute_value: "" }]
  });

  const fetchwarehouseinfo = async (productIdParam) => {
    try {
      const token = sessionStorage.getItem("token") || (typeof rawToken !== "undefined" ? rawToken : "");
      const targetProductId =
        productIdParam ||
        selectedProductDetails?.product_id ||
        selectedProductDetails?.id ||
        selectedProductVariants?.[0]?.product_id ||
        newVariantForm?.product_id;

      if (!targetProductId) {
        console.warn("fetchwarehouseinfo: No product_id available to fetch warehouses");
        return [];
      }

      const res = await axios.get(`${apiEndpoint}/snp/products/get-warehouse/${targetProductId}`, {
        headers: {
          "Content-Type": "application/json",
          "x-custom-authorization": `Bearer ${token}`,
        },
      });

      const responseData = res?.data;
      const rawList =
        responseData?.data ||
        responseData?.warehouses ||
        responseData?.warehouse ||
        responseData?.product_warehouses ||
        responseData?.productWarehouses ||
        responseData;
      const list = Array.isArray(rawList)
        ? rawList
        : (Array.isArray(rawList?.data) ? rawList.data : (rawList && typeof rawList === "object" ? [rawList] : []));
      const normalizedWarehouses = list
        .filter(Boolean)
        .filter((warehouse) => warehouse?.status === true || warehouse?.status === 1 || warehouse?.status === "true" || warehouse?.status === undefined)
        .map((warehouse) => {
          const whId = warehouse.id || warehouse.warehouse_id || warehouse.wh_id || warehouse.warehouse?.id;
          const whName = warehouse.warehouse_name || warehouse.name || warehouse.warehouse?.warehouse_name || warehouse.warehouse?.name || `Warehouse #${whId}`;
          return {
            ...warehouse,
            id: whId,
            warehouse_id: whId,
            warehouse_name: whName,
          };
        })
        .filter((warehouse) => warehouse.id !== undefined && warehouse.id !== null);

      setWarehouses(normalizedWarehouses);
      console.log("Warehouses loaded for variant allocation:", normalizedWarehouses);
      return normalizedWarehouses;
    } catch (err) {
      console.log("Error fetching warehouses in Instorecatalog:", err?.response?.data || err?.message);
      toast.error(err?.response?.data?.message || "Unable to load warehouses");
      return [];
    }
  };

  const fetchWarehouses = fetchwarehouseinfo;

  const [isUploadingVariantImage, setIsUploadingVariantImage] = useState(false);

  const handleVariantImageUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const currentImages = Array.isArray(newVariantForm.image)
      ? newVariantForm.image
      : (newVariantForm.image ? [newVariantForm.image] : []);

    if (currentImages.length >= 4) {
      toast.error("Maximum 4 images allowed! You cannot upload more than 4 images.", { toastId: "max-4-images-error" });
      if (e.target) e.target.value = "";
      return;
    }

    if (currentImages.length + files.length > 4) {
      toast.error(`Maximum 4 images allowed! You already have ${currentImages.length} image(s), so you can only upload ${4 - currentImages.length} more.`, { toastId: "max-4-images-exceeded" });
      if (e.target) e.target.value = "";
      return;
    }

    const MAX_FILE_SIZE = 4 * 1024 * 1024; // 4MB
    const validFiles = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileName = file.name || "";
      const fileType = (file.type || "").toLowerCase();

      if (
        !fileType.startsWith("image/") ||
        fileType === "application/pdf" ||
        fileName.toLowerCase().endsWith(".pdf")
      ) {
        toast.error(`"${fileName}" is not a valid image. PDF and non-image files are not allowed!`);
        if (e.target) e.target.value = "";
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        toast.error(`"${fileName}" exceeds the maximum allowed size of 4MB!`);
        if (e.target) e.target.value = "";
        return;
      }

      validFiles.push(file);
    }

    const formData = new FormData();
    for (let i = 0; i < validFiles.length; i++) {
      formData.append("files", validFiles[i]);
    }

    try {
      setIsUploadingVariantImage(true);
      const token = sessionStorage.getItem("token") || (typeof rawToken !== "undefined" ? rawToken : "");
      const { data } = await axios.post(
        `${apiEndpoint}/snp/upload`,
        formData,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
          }
        }
      );

      if (data?.success && Array.isArray(data?.urls) && data.urls.length > 0) {
        const uploadedUrls = data.urls.filter(Boolean);
        setNewVariantForm((prev) => {
          const existing = Array.isArray(prev.image) ? prev.image : (prev.image ? [prev.image] : []);
          return { ...prev, image: [...existing, ...uploadedUrls].slice(0, 4) };
        });
        toast.success(data.message || `${uploadedUrls.length} image(s) uploaded successfully!`);
      } else {
        toast.error(data?.message || "Image upload failed!");
      }
    } catch (err) {
      console.error("Variant image upload failed:", err);
      toast.error(err?.response?.data?.message || "Upload failed!");
    } finally {
      setIsUploadingVariantImage(false);
      if (e.target) e.target.value = "";
    }
  };

  const handleRemoveVariantImage = (indexToRemove) => {
    setNewVariantForm((prev) => {
      const existing = Array.isArray(prev.image) ? prev.image : (prev.image ? [prev.image] : []);
      return {
        ...prev,
        image: existing.filter((_, idx) => idx !== indexToRemove)
      };
    });
  };

  const handleOpenCreateVariantModal = async (productTypeId, productId) => {
    const targetProductId =
      productId ||
      selectedProductDetails?.product_id ||
      selectedProductDetails?.id ||
      selectedProductVariants?.[0]?.product_id ||
      creatvariant;

    const whList = await fetchwarehouseinfo(targetProductId);
    setEditingVariantId(null);
    setIsVariantDetailsLoading(false);
    let initialAttributes = [{ attribute_name: "", attribute_value: "" }];

    const typeId = productTypeId || selectedProductDetails?.product_type_id || selectedProductVariants?.[0]?.product_type_id;
    if (typeId) {
      try {
        const token = sessionStorage.getItem("token") || "";
        const res = await axios.get(`${apiEndpoint}/snp/products/get-attributes/${typeId}`, {
          headers: {
            "Content-Type": "application/json",
            "x-custom-authorization": `Bearer ${token}`,
          }
        });
        const fetchedAttrs = res?.data?.data || res?.data?.attributes || (Array.isArray(res?.data) ? res?.data : []);
        if (Array.isArray(fetchedAttrs) && fetchedAttrs.length > 0) {
          initialAttributes = fetchedAttrs.map(attr => ({
            id: attr.id,
            product_type_id: attr.product_type_id,
            attribute_name: typeof attr === "string" ? attr : (attr.product_type_attribute || attr.attribute_name || attr.name || ""),
            attribute_value: typeof attr === "object" ? (attr.attribute_value || attr.value || "") : "",
            is_mandatory: Boolean(attr.is_mandatory)
          }));
        }
      } catch (err) {
        console.error("Error fetching product type attributes:", err);
      }
    }

    setNewVariantForm({
      sku: "",
      product_id: targetProductId || "",
      warehouse_id: "",
      warehouse_location_id: "",
      hsn: "",
      weights: "",
      image: [],
      mrp: "",
      selling_price: "",
      quantity: "",
      available_qty: "",
      min_quantity: "",
      max_quantity: "",
      uom: "",
      uom_value: "",
      pack_config_set: "",
      pack_config_case: "",
      pack_config_selling_unit: "",
      packing_height: "",
      packing_length: "",
      packing_breadth: "",
      packing_weight: "",
      packing_price: "",
      returnable: "",
      cancellable: "",
      replaceable: "",
      seller_pickup_return: "",
      cod_allowed: "",
      status: "",
      return_window: "",
      time_to_ship: "",
      time_to_deliver: "",
      attributes: initialAttributes
    });

    const initialWhObj = {};
    const initialQtyObj = {};
    (whList || []).forEach((wh) => {
      const whIdStr = String(wh.id);
      initialWhObj[whIdStr] = true;
      initialQtyObj[whIdStr] = wh.available_qty !== undefined && wh.available_qty !== null
        ? String(wh.available_qty)
        : (wh.quantity !== undefined && wh.quantity !== null ? String(wh.quantity) : "10");
    });
    setVariantWarehouses(initialWhObj);
    setVariantWarehouseQty(initialQtyObj);
    setTempVariantWarehouses([]);
    setTempVariantQty("");
    setCreateVariantModalOpen(true);
  };

  const handleOpenEditVariantModal = async (variantInput) => {
    const varId = typeof variantInput === "object" ? (variantInput?.id || variantInput?.product_variant_id || variantInput?.variation_id || null) : variantInput;
    setEditingVariantId(varId);
    setCreateVariantModalOpen(true);
    setIsVariantDetailsLoading(true);

    const targetProductId =
      selectedProductDetails?.product_id ||
      selectedProductDetails?.id ||
      (typeof variantInput === "object" ? variantInput?.product_id : null);
    if (targetProductId) {
      await fetchwarehouseinfo(targetProductId);
    }

    try {
      let variantData = typeof variantInput === "object" ? variantInput : (Array.isArray(selectedProductVariants) ? selectedProductVariants.find(v => String(v.id) === String(varId)) : null);

      if (varId) {
        try {
          const token = sessionStorage.getItem("token") || (typeof rawToken !== "undefined" ? rawToken : "");
          const response = await axios({
            url: `${apiEndpoint}/snp/products/get-variant/${varId}`,
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-custom-authorization": `Bearer ${token}`,

            },
          });

          const fetchedVariant =
            (Array.isArray(response?.data?.variants) && response.data.variants.length > 0)
              ? (response.data.variants.find(item => String(item.id) === String(varId) || String(item.product_variant_id) === String(varId)) || response.data.variants[0])
              : (response?.data?.variant ||
                (Array.isArray(response?.data?.data) ? response.data.data[0] : response?.data?.data) ||
                (Array.isArray(response?.data?.product) ? response.data.product[0] : response?.data));

          if (fetchedVariant && typeof fetchedVariant === "object") {
            variantData = { ...(variantData || {}), ...fetchedVariant };
          }
        } catch (err) {
          console.log("get-variant API call fallback to local variant data:", err?.response?.data || err?.message);
        }
      }
      const v = variantData || (typeof variantInput === "object" ? variantInput : {}) || {};

      const productType =
        selectedProductDetails?.product_type_id ||
        selectedProductDetails?.product_type ||
        selectedProductDetails?.category_id;

      let ptAttributes = [];
      if (productType) {
        try {
          const token = sessionStorage.getItem("token") || (typeof rawToken !== "undefined" ? rawToken : "");
          const res = await axios.get(
            `${apiEndpoint}/snp/products/get-attributes/${productType}`,
            {
              headers: {
                "Content-Type": "application/json",
                "x-custom-authorization": `Bearer ${token}`,
              },
            }
          );
          const data = res?.data?.data || (Array.isArray(res?.data) ? res?.data : []);
          ptAttributes = data.map((attr) => ({
            attribute_name: attr.product_type_attribute || attr.attribute_name,
            attribute_value: "",
            is_mandatory: Boolean(attr.is_mandatory),
            product_type_id: attr.product_type_id || productType,
          }));
        } catch (err) {
          console.error("Error fetching product type attributes for edit:", err);
        }
      }

      let existingAttrs = [];
      if (Array.isArray(v?.attributes) && v.attributes.length > 0) {
        existingAttrs = v.attributes.map((a) => ({
          id: a.id,
          attribute_name: a.attribute_name || a.name || "",
          attribute_value: a.attribute_value !== undefined && a.attribute_value !== null ? String(a.attribute_value) : (a.value || ""),
          is_mandatory: Boolean(a.is_mandatory),
        }));
      } else if (v?.features && typeof v.features === "object") {
        existingAttrs = Object.keys(v.features).map((key) => ({
          attribute_name: key,
          attribute_value: String(v.features[key] || ""),
          is_mandatory: false,
        }));
      }

      let mergedAttributes = [];
      if (ptAttributes.length > 0) {
        mergedAttributes = ptAttributes.map((ptAttr) => {
          const matched = existingAttrs.find(
            (ea) => ea.attribute_name.toLowerCase().trim() === ptAttr.attribute_name.toLowerCase().trim()
          );
          return {
            ...ptAttr,
            id: matched?.id || undefined,
            attribute_value: matched ? matched.attribute_value : "",
          };
        });

        existingAttrs.forEach((eAttr) => {
          const alreadyIncluded = mergedAttributes.some(
            (ma) => ma.attribute_name.toLowerCase().trim() === eAttr.attribute_name.toLowerCase().trim()
          );
          if (!alreadyIncluded && eAttr.attribute_name) {
            mergedAttributes.push(eAttr);
          }
        });
      } else if (existingAttrs.length > 0) {
        mergedAttributes = existingAttrs;
      } else {
        mergedAttributes = [{ attribute_name: "", attribute_value: "" }];
      }

      const initialWhIds = Array.isArray(v?.inventories) && v.inventories.length > 0
        ? v.inventories.map((inv) => String(inv.warehouse_id)).filter(Boolean)
        : (v?.warehouse_id ? [String(v.warehouse_id)] : []);

      const initialWhObj = {};
      const initialQtyObj = {};
      if (Array.isArray(v?.inventories) && v.inventories.length > 0) {
        v.inventories.forEach(inv => {
          if (inv.warehouse_id !== undefined && inv.warehouse_id !== null) {
            const idStr = String(inv.warehouse_id);
            initialWhObj[idStr] = true;
            initialQtyObj[idStr] = inv.available_qty !== undefined && inv.available_qty !== null
              ? String(inv.available_qty)
              : (inv.quantity !== undefined && inv.quantity !== null ? String(inv.quantity) : "0");
          }
        });
      } else if (v?.warehouse_id) {
        const idStr = String(v.warehouse_id);
        initialWhObj[idStr] = true;
        initialQtyObj[idStr] = String(v.available_qty || v.quantity || "0");
      }

      setVariantWarehouses(initialWhObj);
      setVariantWarehouseQty(initialQtyObj);
      setTempVariantWarehouses([]);
      setTempVariantQty("");

      let parsedImages = [];
      if (Array.isArray(v?.image)) {
        parsedImages = v.image.filter(Boolean);
      } else if (typeof v?.image === "string" && v.image.trim()) {
        if (v.image.startsWith("[") && v.image.endsWith("]")) {
          try {
            const parsed = JSON.parse(v.image);
            if (Array.isArray(parsed)) parsedImages = parsed.filter(Boolean);
          } catch (e) {
            parsedImages = v.image.split(",").map(s => s.trim()).filter(Boolean);
          }
        } else {
          parsedImages = v.image.split(",").map(s => s.trim()).filter(Boolean);
        }
      } else if (Array.isArray(v?.images)) {
        parsedImages = v.images.map(img => typeof img === "object" ? (img?.url || img?.image || "") : img).filter(Boolean);
      }

      let packingDetailsObj = v?.packing_details;
      if (typeof packingDetailsObj === "string") {
        try {
          packingDetailsObj = JSON.parse(packingDetailsObj);
        } catch (e) {
          packingDetailsObj = {};
        }
      }

      const parsePackingVal = (field) => {
        if (field !== undefined && field !== null) {
          if (typeof field === "object" && field?.value !== undefined && field?.value !== null) {
            return field.value;
          }
          return field;
        }
        return "";
      };

      let packConfigObj = v?.pack_config;
      if (typeof packConfigObj === "string") {
        try {
          packConfigObj = JSON.parse(packConfigObj);
        } catch (e) {
          packConfigObj = {};
        }
      }

      const fulfillmentObj = Array.isArray(v?.fulfillment) ? (v.fulfillment[0] || {}) : (v?.fulfillment || {});
      const priceObj = Array.isArray(v?.price) ? (v.price[0] || {}) : (v?.price || {});

      setNewVariantForm({
        id: varId || v?.id || v?.product_variant_id || "",
        product_variant_id: varId || v?.id || v?.product_variant_id || "",
        sku: v?.sku || "",
        product_id: v?.product_id || selectedProductDetails?.id || "",
        warehouse_id: initialWhIds[0] || v?.inventories?.[0]?.warehouse_id || v?.warehouse_id || "",
        warehouse_ids: initialWhIds,
        warehouse_location_id: v?.inventories?.[0]?.warehouse_location_id,
        inventory_id: v?.inventories?.[0]?.id || "",
        hsn: v?.hsn || "",
        weights: v?.weights ?? v?.weight ?? parsePackingVal(packingDetailsObj?.weight) ?? "",
        image: parsedImages,
        mrp: priceObj?.mrp ?? priceObj?.base_price ?? v?.mrp ?? "",
        selling_price: priceObj?.selling_price ?? priceObj?.current_price ?? v?.selling_price ?? "",
        quantity: v?.available_qty ?? v?.quantity ?? (Array.isArray(v?.inventories) && v.inventories.length > 0 ? v.inventories[0]?.available_qty ?? "" : ""),
        available_qty: v?.inventories?.[0]?.available_qty ?? v?.available_qty ?? "",
        min_quantity: v?.min_quantity ?? "",
        max_quantity: v?.max_quantity ?? "",
        uom: v?.uom || "unit",
        uom_value: v?.uom_value ?? "",
        pack_config_set: packConfigObj?.set ?? v?.pack_config_set ?? "",
        pack_config_case: packConfigObj?.case ?? v?.pack_config_case ?? "",
        pack_config_selling_unit: packConfigObj?.selling_unit ?? v?.pack_config_selling_unit ?? "",
        packing_height: parsePackingVal(packingDetailsObj?.height),
        packing_length: parsePackingVal(packingDetailsObj?.length),
        packing_breadth: parsePackingVal(packingDetailsObj?.breadth),
        packing_weight: parsePackingVal(packingDetailsObj?.weight) !== "" ? parsePackingVal(packingDetailsObj?.weight) : (v?.weights ?? v?.weight ?? ""),
        packing_price: parsePackingVal(packingDetailsObj?.price) !== "" ? parsePackingVal(packingDetailsObj?.price) : (priceObj?.mrp ?? priceObj?.base_price ?? v?.mrp ?? ""),
        returnable: Boolean(fulfillmentObj?.returnable ?? v?.returnable ?? false),
        cancellable: Boolean(fulfillmentObj?.cancellable ?? fulfillmentObj?.cancelable ?? v?.cancellable ?? v?.cancelable ?? false),
        replaceable: Boolean(fulfillmentObj?.replaceable ?? v?.replaceable ?? false),
        seller_pickup_return: Boolean(fulfillmentObj?.seller_pickup_return ?? v?.seller_pickup_return ?? false),
        cod_allowed: Boolean(fulfillmentObj?.cod_allowed ?? v?.cod_allowed ?? false),
        status: (fulfillmentObj?.status ?? v?.status) !== false && (fulfillmentObj?.status ?? v?.status) !== 0 && (fulfillmentObj?.status ?? v?.status) !== "0",
        return_window: fulfillmentObj?.return_window || v?.return_window,
        time_to_ship: fulfillmentObj?.time_to_ship || v?.time_to_ship,
        time_to_deliver: fulfillmentObj?.time_to_deliver || v?.time_to_deliver,
        attributes: mergedAttributes
      });
    } catch (finalErr) {
      console.error("Error setting variant edit modal form:", finalErr);
    } finally {
      setIsVariantDetailsLoading(false);
    }
  };

  const handleCreateVariantSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!newVariantForm.sku || !String(newVariantForm.sku).trim()) {
      toast.error("SKU Code is mandatory!", { toastId: "create-var-sku-error" });
      return;
    }

    const mrpNum = Number(newVariantForm.mrp || 0);
    const sellingNum = Number(newVariantForm.selling_price || 0);

    if (!newVariantForm.mrp || mrpNum <= 0) {
      toast.error("MRP is mandatory and must be greater than 0!", { toastId: "create-var-mrp-error" });
      return;
    }

    if (!newVariantForm.selling_price || sellingNum <= 0) {
      toast.error("Selling price is mandatory and must be greater than 0!", { toastId: "create-var-sp-error" });
      return;
    }

    if (sellingNum > mrpNum) {
      toast.error("Selling price cannot be greater than MRP price!", { toastId: "create-var-price-error" });
      return;
    }

    const activeWhIds = Object.keys(variantWarehouses).filter(id => variantWarehouses[id]);
    if (!activeWhIds || activeWhIds.length === 0) {
      toast.error("Warehouse Inventory Allocation is mandatory! Please add at least one warehouse.", { toastId: "create-wh-required" });
      return;
    }

    for (const wId of activeWhIds) {
      const qty = variantWarehouseQty[String(wId)];
      if (qty === undefined || qty === null || String(qty).trim() === "" || isNaN(Number(qty)) || Number(qty) < 0) {
        const whName = warehouses?.find(w => String(w.id) === String(wId))?.warehouse_name || `Warehouse #${wId}`;
        toast.error(`Please enter a valid quantity (0 or more) for ${whName}!`, { toastId: `create-wh-qty-${wId}` });
        return;
      }
    }

    for (const attr of newVariantForm.attributes || []) {
      if (attr.is_mandatory && (!attr.attribute_value || String(attr.attribute_value).trim() === "")) {
        toast.error(`${attr.attribute_name || "Attribute"} is mandatory!`, { toastId: `mandatory-attr-${attr.attribute_name}` });
        return;
      }
    }

    if (!newVariantForm.uom || !String(newVariantForm.uom).trim()) {
      toast.error("Unit of Measurement (UOM) is mandatory!", { toastId: "create-var-uom-error" });
      return;
    }

    const uomValNum = Number(newVariantForm.uom_value || 0);
    if (!newVariantForm.uom_value || isNaN(uomValNum) || uomValNum <= 0) {
      toast.error("UOM Value is mandatory and must be greater than 0!", { toastId: "create-var-uom-val-error" });
      return;
    }

    const minQtyNum = Number(newVariantForm.min_quantity || 0);
    if (!newVariantForm.min_quantity || isNaN(minQtyNum) || minQtyNum < 1) {
      toast.error("Min Quantity is mandatory and must be at least 1!", { toastId: "create-var-min-qty-error" });
      return;
    }

    const maxQtyNum = Number(newVariantForm.max_quantity || 0);
    if (!newVariantForm.max_quantity || isNaN(maxQtyNum) || maxQtyNum < 1) {
      toast.error("Max Quantity is mandatory and must be at least 1!", { toastId: "create-var-max-qty-error" });
      return;
    }

    if (maxQtyNum < minQtyNum) {
      toast.error(`Max Quantity (${maxQtyNum}) cannot be less than Min Quantity (${minQtyNum})! Max Quantity must be greater than or equal to Min Quantity.`, { toastId: "create-var-max-min-qty-error" });
      return;
    }

    if (!newVariantForm.return_window || !String(newVariantForm.return_window).trim()) {
      toast.error("Return Window is mandatory!", { toastId: "create-var-rw-error" });
      return;
    }

    if (!newVariantForm.time_to_ship || !String(newVariantForm.time_to_ship).trim()) {
      toast.error("Time To Ship is mandatory!", { toastId: "create-var-tts-error" });
      return;
    }

    if (!newVariantForm.time_to_deliver || !String(newVariantForm.time_to_deliver).trim()) {
      toast.error("Time To Deliver is mandatory!", { toastId: "create-var-ttd-error" });
      return;
    }

    if (newVariantForm.returnable === undefined || newVariantForm.returnable === null || newVariantForm.returnable === "") {
      toast.error("Returnable is mandatory!", { toastId: "create-var-returnable-error" });
      return;
    }

    if (newVariantForm.cancellable === undefined || newVariantForm.cancellable === null || newVariantForm.cancellable === "") {
      toast.error("Cancellable is mandatory!", { toastId: "create-var-cancellable-error" });
      return;
    }

    if (newVariantForm.replaceable === undefined || newVariantForm.replaceable === null || newVariantForm.replaceable === "") {
      toast.error("Replaceable is mandatory!", { toastId: "create-var-replaceable-error" });
      return;
    }

    if (newVariantForm.seller_pickup_return === undefined || newVariantForm.seller_pickup_return === null || newVariantForm.seller_pickup_return === "") {
      toast.error("Seller Pickup Return is mandatory!", { toastId: "create-var-spr-error" });
      return;
    }

    if (newVariantForm.cod_allowed === undefined || newVariantForm.cod_allowed === null || newVariantForm.cod_allowed === "") {
      toast.error("COD Allowed is mandatory!", { toastId: "create-var-cod-error" });
      return;
    }

    if (newVariantForm.status === undefined || newVariantForm.status === null || newVariantForm.status === "") {
      toast.error("Active Status is mandatory!", { toastId: "create-var-status-error" });
      return;
    }

    const imgList = Array.isArray(newVariantForm.image) ? newVariantForm.image.filter(Boolean) : (newVariantForm.image ? [newVariantForm.image] : []);
    if (!imgList || imgList.length === 0) {
      toast.error("Variant Image is mandatory! Please upload at least one image.", { toastId: "create-var-img-error" });
      return;
    }

    const parentProductId = selectedProductVariants?.[0]?.product_id || selectedProductDetails?.id || selectedProductDetails?.product_id;

    if (!parentProductId) {
      toast.error("Product ID not found. Cannot create variant.");
      return;
    }

    try {
      setIsSubmittingVariant(true);
      const token = sessionStorage.getItem("token") || (typeof rawToken !== "undefined" ? rawToken : "");
      const headers = {
        "Content-Type": "application/json",
        "x-custom-authorization": `Bearer ${token}`,
      };

      const qtyVal = Number(newVariantForm.quantity || newVariantForm.available_qty || 0);
      const weightVal = Number(newVariantForm.weights || 0);

      // features me sirf EK attribute jayega (pehla jo filled hai)
      // Agar koi attribute filled nahi hai to features khali {} rahega
      const featuresObj = {};
      const firstFilledAttr = (newVariantForm.attributes || []).find(
        (a) =>
          a?.attribute_name &&
          String(a.attribute_name).trim() !== "" &&
          a?.attribute_value !== undefined &&
          a?.attribute_value !== null &&
          String(a.attribute_value).trim() !== ""
      );

      if (firstFilledAttr) {
        featuresObj[String(firstFilledAttr.attribute_name).trim()] = String(firstFilledAttr.attribute_value).trim();
      }
      const inventoriesArr = activeWhIds.map(wId => {
        const whQty = variantWarehouseQty[String(wId)] !== undefined && variantWarehouseQty[String(wId)] !== ""
          ? Number(variantWarehouseQty[String(wId)])
          : qtyVal;
        return {
          warehouse_id: Number(wId),
          ...(newVariantForm.warehouse_location_id ? { warehouse_location_id: String(newVariantForm.warehouse_location_id) } : {}),
          quantity: whQty,
          available_qty: whQty,
          status: true
        };
      });

      const imgArray = Array.isArray(newVariantForm.image) ? newVariantForm.image.filter(Boolean) : (newVariantForm.image ? [newVariantForm.image] : []);
      const imgStr = imgArray.join(",");

      const variantItem = {
        sku: newVariantForm.sku || `SKU-${Date.now()}`,
        ...(weightVal > 0 ? { weights: weightVal } : {}),
        features: featuresObj,
        hsn: newVariantForm.hsn || "",
        image: imgStr || imgArray[0] || "",
        // images: imgArray,
        uom: newVariantForm.uom || "piece",
        uom_value: Number(newVariantForm.uom_value || 1),
        max_quantity: Number(newVariantForm.max_quantity || (qtyVal > 0 ? qtyVal : 100)),
        min_quantity: Number(newVariantForm.min_quantity || 1),
        features: featuresObj,
        pack_config: {
          set: isNaN(Number(newVariantForm.pack_config_set)) ? newVariantForm.pack_config_set || 1 : Number(newVariantForm.pack_config_set || 1),
          case: isNaN(Number(newVariantForm.pack_config_case)) ? (newVariantForm.pack_config_case || "1") : String(newVariantForm.pack_config_case || "1"),
          selling_unit: Number(newVariantForm.pack_config_selling_unit || 1)
        },
        packing_details: {
          price: { unit: "INR", value: Number(newVariantForm.packing_price || mrpNum) },
          height: { unit: "cm", value: Number(newVariantForm.packing_height || 10) },
          length: { unit: "cm", value: Number(newVariantForm.packing_length || 20) },
          breadth: { unit: "cm", value: Number(newVariantForm.packing_breadth || 15) }
        },
        price: [
          {
            currency: "INR",
            base_price: mrpNum,
            current_price: sellingNum,
            status: true
          }
        ],
        attributes: (newVariantForm.attributes || [])
          .filter(a => a.attribute_name && a.attribute_value !== "" && a.attribute_value !== null)
          .map(a => ({
            attribute_name: a.attribute_name.trim(),
            attribute_value: isNaN(Number(a.attribute_value)) ? a.attribute_value.trim() : Number(a.attribute_value)
          })),
        returnable: Boolean(newVariantForm.returnable),
        cancellable: Boolean(newVariantForm.cancellable),
        replaceable: Boolean(newVariantForm.replaceable),
        seller_pickup_return: Boolean(newVariantForm.seller_pickup_return),
        return_window: newVariantForm.return_window || "P7D",
        time_to_ship: newVariantForm.time_to_ship || "P2D",
        time_to_deliver: newVariantForm.time_to_deliver || "P7D",
        cod_allowed: Boolean(newVariantForm.cod_allowed),
        status: Boolean(newVariantForm.status),
        inventories: inventoriesArr
      };

      const payload = {
        variants: [variantItem]
      };

      await axios.post(
        `${apiEndpoint}/snp/products/add-product-variant/${parentProductId}`,
        payload,
        { headers }
      );

      toast.success("Variant added successfully!");
      setCreateVariantModalOpen(false);
      setEditingVariantId(null);
      const freshProducts = await getproductlist(parentProductId);
      const freshTargetProduct = Array.isArray(freshProducts)
        ? freshProducts.find(p => String(p.id) === String(parentProductId) || String(p.product_id) === String(parentProductId))
        : null;
      handleOpenVariantsModal(parentProductId, selectedProductDetails?.name, freshTargetProduct);
    } catch (error) {
      console.error("Create variant error:", error);
      toast.error(error?.response?.data?.message || "Failed to create variant");
    } finally {
      setIsSubmittingVariant(false);
    }
  };

  const handleUpdateVariantSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!newVariantForm.sku || !String(newVariantForm.sku).trim()) {
      toast.error("SKU Code is mandatory!", { toastId: "update-var-sku-error" });
      return;
    }

    const mrpNum = Number(newVariantForm.mrp || 0);
    const sellingNum = Number(newVariantForm.selling_price || 0);

    if (!newVariantForm.mrp || mrpNum <= 0) {
      toast.error("MRP is mandatory and must be greater than 0!", { toastId: "update-var-mrp-error" });
      return;
    }

    if (!newVariantForm.selling_price || sellingNum <= 0) {
      toast.error("Selling price is mandatory and must be greater than 0!", { toastId: "update-var-sp-error" });
      return;
    }

    if (sellingNum > mrpNum) {
      toast.error("Selling price cannot be greater than MRP price!", { toastId: "update-var-price-error" });
      return;
    }

    const activeWhIds = Object.keys(variantWarehouses).filter(id => variantWarehouses[id]);
    if (!activeWhIds || activeWhIds.length === 0) {
      toast.error("Warehouse Inventory Allocation is mandatory! Please add at least one warehouse.", { toastId: "update-wh-required" });
      return;
    }

    for (const wId of activeWhIds) {
      const qty = variantWarehouseQty[String(wId)];
      if (qty === undefined || qty === null || String(qty).trim() === "" || isNaN(Number(qty)) || Number(qty) < 0) {
        const whName = warehouses?.find(w => String(w.id) === String(wId))?.warehouse_name || `Warehouse #${wId}`;
        toast.error(`Please enter a valid quantity (0 or more) for ${whName}!`, { toastId: `update-wh-qty-${wId}` });
        return;
      }
    }

    for (const attr of newVariantForm.attributes || []) {
      if (attr.is_mandatory && (!attr.attribute_value || String(attr.attribute_value).trim() === "")) {
        toast.error(`${attr.attribute_name || "Attribute"} is mandatory!`, { toastId: `mandatory-attr-${attr.attribute_name}` });
        return;
      }
    }

    if (!newVariantForm.uom || !String(newVariantForm.uom).trim()) {
      toast.error("Unit of Measurement (UOM) is mandatory!", { toastId: "update-var-uom-error" });
      return;
    }

    const uomValNumUpdate = Number(newVariantForm.uom_value || 0);
    if (!newVariantForm.uom_value || isNaN(uomValNumUpdate) || uomValNumUpdate <= 0) {
      toast.error("UOM Value is mandatory and must be greater than 0!", { toastId: "update-var-uom-val-error" });
      return;
    }

    const minQtyNumUpdate = Number(newVariantForm.min_quantity || 0);
    if (!newVariantForm.min_quantity || isNaN(minQtyNumUpdate) || minQtyNumUpdate < 1) {
      toast.error("Min Quantity is mandatory and must be at least 1!", { toastId: "update-var-min-qty-error" });
      return;
    }

    const maxQtyNumUpdate = Number(newVariantForm.max_quantity || 0);
    if (!newVariantForm.max_quantity || isNaN(maxQtyNumUpdate) || maxQtyNumUpdate < 1) {
      toast.error("Max Quantity is mandatory and must be at least 1!", { toastId: "update-var-max-qty-error" });
      return;
    }

    if (maxQtyNumUpdate < minQtyNumUpdate) {
      toast.error(`Max Quantity (${maxQtyNumUpdate}) cannot be less than Min Quantity (${minQtyNumUpdate})! Max Quantity must be greater than or equal to Min Quantity.`, { toastId: "update-var-max-min-qty-error" });
      return;
    }

    if (!newVariantForm.return_window || !String(newVariantForm.return_window).trim()) {
      toast.error("Return Window is mandatory!", { toastId: "update-var-rw-error" });
      return;
    }

    if (!newVariantForm.time_to_ship || !String(newVariantForm.time_to_ship).trim()) {
      toast.error("Time To Ship is mandatory!", { toastId: "update-var-tts-error" });
      return;
    }

    if (!newVariantForm.time_to_deliver || !String(newVariantForm.time_to_deliver).trim()) {
      toast.error("Time To Deliver is mandatory!", { toastId: "update-var-ttd-error" });
      return;
    }

    if (newVariantForm.returnable === undefined || newVariantForm.returnable === null || newVariantForm.returnable === "") {
      toast.error("Returnable is mandatory!", { toastId: "update-var-returnable-error" });
      return;
    }

    if (newVariantForm.cancellable === undefined || newVariantForm.cancellable === null || newVariantForm.cancellable === "") {
      toast.error("Cancellable is mandatory!", { toastId: "update-var-cancellable-error" });
      return;
    }

    if (newVariantForm.replaceable === undefined || newVariantForm.replaceable === null || newVariantForm.replaceable === "") {
      toast.error("Replaceable is mandatory!", { toastId: "update-var-replaceable-error" });
      return;
    }

    if (newVariantForm.seller_pickup_return === undefined || newVariantForm.seller_pickup_return === null || newVariantForm.seller_pickup_return === "") {
      toast.error("Seller Pickup Return is mandatory!", { toastId: "update-var-spr-error" });
      return;
    }

    if (newVariantForm.cod_allowed === undefined || newVariantForm.cod_allowed === null || newVariantForm.cod_allowed === "") {
      toast.error("COD Allowed is mandatory!", { toastId: "update-var-cod-error" });
      return;
    }

    if (newVariantForm.status === undefined || newVariantForm.status === null || newVariantForm.status === "") {
      toast.error("Active Status is mandatory!", { toastId: "update-var-status-error" });
      return;
    }

    const imgListUpdate = Array.isArray(newVariantForm.image) ? newVariantForm.image.filter(Boolean) : (newVariantForm.image ? [newVariantForm.image] : []);
    if (!imgListUpdate || imgListUpdate.length === 0) {
      toast.error("Variant Image is mandatory! Please upload at least one image.", { toastId: "update-var-img-error" });
      return;
    }

    try {
      setIsSubmittingVariant(true);
      const token = sessionStorage.getItem("token") || (typeof rawToken !== "undefined" ? rawToken : "");
      const headers = {
        "Content-Type": "application/json",
        "x-custom-authorization": `Bearer ${token}`,
      };

      const qtyVal = Number(newVariantForm.quantity || newVariantForm.available_qty || 0);
      const weightVal = Number(newVariantForm.weights || 0);

      // productVariantId: editing variant ki ID (jaise "329")
      const productVariantId =
        editingVariantId ||
        newVariantForm?.id ||
        newVariantForm?.product_variant_id ||
        newVariantForm?.attributes?.[0]?.product_variant_id;

      if (!productVariantId) {
        toast.error("Product Variant ID not found. Cannot update variant.");
        setIsSubmittingVariant(false);
        return;
      }

      const parentProductId =
        selectedProductDetails?.id ||
        selectedProductDetails?.product_id ||
        newVariantForm?.product_id ||
        selectedProductVariants?.[0]?.product_id;


      // features me sirf EK attribute jayega (pehla jo filled hai)
      // Agar koi attribute filled nahi hai to features khali {} rahega
      const featuresObj = {};
      const firstFilledAttr = (newVariantForm.attributes || []).find(
        (a) =>
          a?.attribute_name &&
          String(a.attribute_name).trim() !== "" &&
          a?.attribute_value !== undefined &&
          a?.attribute_value !== null &&
          String(a.attribute_value).trim() !== ""
      );

      if (firstFilledAttr) {
        featuresObj[String(firstFilledAttr.attribute_name).trim()] = String(firstFilledAttr.attribute_value).trim();
      }
      const inventoriesArr = activeWhIds.map(wId => {
        const whQty = variantWarehouseQty[String(wId)] !== undefined && variantWarehouseQty[String(wId)] !== ""
          ? Number(variantWarehouseQty[String(wId)])
          : qtyVal;
        return {
          warehouse_id: Number(wId),
          ...(newVariantForm.warehouse_location_id ? { warehouse_location_id: String(newVariantForm.warehouse_location_id) } : {}),
          quantity: whQty,
          available_qty: whQty,
          status: true
        };
      });

      const imgArray = Array.isArray(newVariantForm.image) ? newVariantForm.image.filter(Boolean) : (newVariantForm.image ? [newVariantForm.image] : []);
      const imgStr = imgArray.join(",");

      const variantItem = {
        sku: newVariantForm.sku || `SKU-${Date.now()}`,
        ...(weightVal > 0 ? { weights: weightVal } : {}),
        hsn: newVariantForm.hsn || "",
        image: imgStr || imgArray[0] || "",
        // images: imgArray,
        uom: newVariantForm.uom,
        uom_value: Number(newVariantForm.uom_value || 1),
        max_quantity: Number(newVariantForm.max_quantity || (qtyVal > 0 ? qtyVal : 100)),
        min_quantity: Number(newVariantForm.min_quantity || 1),
        features: featuresObj,
        pack_config: {
          set: isNaN(Number(newVariantForm.pack_config_set)) ? newVariantForm.pack_config_set || 1 : Number(newVariantForm.pack_config_set || 1),
          case: isNaN(Number(newVariantForm.pack_config_case)) ? (newVariantForm.pack_config_case || "1") : String(newVariantForm.pack_config_case || "1"),
          selling_unit: Number(newVariantForm.pack_config_selling_unit || 1)
        },
        packing_details: {
          price: { unit: "INR", value: Number(newVariantForm.packing_price || mrpNum) },
          height: { unit: "cm", value: Number(newVariantForm.packing_height) },
          length: { unit: "cm", value: Number(newVariantForm.packing_length) },
          breadth: { unit: "cm", value: Number(newVariantForm.packing_breadth) }
        },
        price: [
          {
            currency: "INR",
            base_price: mrpNum,
            current_price: sellingNum,
            status: true
          }
        ],
        attributes: (newVariantForm.attributes || [])
          .filter(a => a.attribute_name && a.attribute_value !== "" && a.attribute_value !== null)
          .map(a => ({
            ...(a.id ? { id: a.id } : {}),
            attribute_name: a.attribute_name.trim(),
            attribute_value: isNaN(Number(a.attribute_value)) ? a.attribute_value.trim() : Number(a.attribute_value)
          })),
        returnable: Boolean(newVariantForm.returnable),
        cancellable: Boolean(newVariantForm.cancellable),
        replaceable: Boolean(newVariantForm.replaceable),
        seller_pickup_return: Boolean(newVariantForm.seller_pickup_return),
        return_window: newVariantForm.return_window,
        time_to_ship: newVariantForm.time_to_ship,
        time_to_deliver: newVariantForm.time_to_deliver,
        cod_allowed: Boolean(newVariantForm.cod_allowed),
        status: Boolean(newVariantForm.status),
        inventories: inventoriesArr
      };

      const payload = {
        variants: [variantItem]
      };

      await axios.put(
        `${apiEndpoint}/snp/products/update-product-variant/${productVariantId}`,
        payload,
        { headers }
      );

      toast.success("Variant updated successfully!");
      setCreateVariantModalOpen(false);
      setEditingVariantId(null);
      const freshProducts = await getproductlist(parentProductId);
      const freshTargetProduct = Array.isArray(freshProducts)
        ? freshProducts.find(p => String(p.id) === String(parentProductId) || String(p.product_id) === String(parentProductId))
        : null;
      handleOpenVariantsModal(parentProductId, selectedProductDetails?.name, freshTargetProduct);
    } catch (error) {
      console.error("Update variant error:", error);
      const msg = error?.response?.data?.message;
      const errText = Array.isArray(msg)
        ? msg.join(", ")
        : (msg || "Failed to update variant");
      toast.error(errText);
    } finally {
      setIsSubmittingVariant(false);
    }
  };

  const handleOpenVariantsModal = (productId, productName, productItem) => {
    if (!productId) return;
    setVariantsModalOpen(true);
    setVariantsModalLoading(false);

    const targetProduct = productItem || (Array.isArray(productlist) ? productlist.find(p => String(p.id) === String(productId) || String(p.product_id) === String(productId)) : null);

    const variantsArr = Array.isArray(targetProduct?.variants)
      ? targetProduct.variants
      : (Array.isArray(targetProduct) ? targetProduct : []);

    const productObj = {
      id: productId,
      name: productName || targetProduct?.name || "",
      product_id: variantsArr?.[0]?.product_id || targetProduct?.id || productId,
      product_type_id: targetProduct?.product_type_id || targetProduct?.product_type || variantsArr?.[0]?.product_type_id || "",
    };

    setSelectedProductDetails(productObj);
    setSelectedProductVariants(variantsArr);
  };
  const handleSyncModalClose = () => {
    setOpen(false);
    setsyncingData({
      seller_id: current_sellerid.toString(),
      price: false,
      inventory: false,
      sku: false,
      title: false,
      weight: false
    })
  }
  const syncmodalstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: "10px",
    boxShadow: 24,
    p: 2,
  };

  async function getproductlist(targetProductIdToRefresh) {
    let parentId = decoded?.data?.user?.parent_id;
    let SellerId = decoded?.data?.user?.seller_id;

    let payload;
    if (parentId > 1) {
      payload = { seller_id: parentId }
    } else {
      payload = { seller_id: SellerId }
    }
    setproductisLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/snp/products/getall`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      if (data.status === true || data.status === 200 || data.status) {
        setItemOffset(0);
        const products = Array.isArray(data?.data) ? data.data : [];
        setproductlist(products);
        setNoproducts(products.length < 1);

        const checkProductId = targetProductIdToRefresh || selectedProductDetails?.id || selectedProductDetails?.product_id;
        if (checkProductId) {
          const freshTargetProduct = products.find(p => String(p.id) === String(checkProductId) || String(p.product_id) === String(checkProductId));
          if (freshTargetProduct && Array.isArray(freshTargetProduct.variants)) {
            setSelectedProductVariants(freshTargetProduct.variants);
          }
        }
        return products;
      } else {
        setproductlist([]);
        setNoproducts(true);
        return [];
      }
    } catch (error) {
      console.log(error);
      setproductlist([]);
      setNoproducts(true);
      return [];
    } finally {
      setproductisLoading(false);
    }
  }


  function maxPriceHandler(id) {
    setopenInput(openInput === id ? null : id);
    const maxPriceProduct = productlist.filter((item) => item.id === id);
    // setquickUpdatedMaxPrice2(...maxPriceProduct);
    let mp;
    // console.log("maxPriceProduct---", maxPriceProduct)
    if (maxPriceProduct?.tax_included_price) {
      mp = maxPriceProduct.tax_included_price;
      // console.log("mp--->", mp)
      // setquickUpdatedMaxPrice(mp);
    } else if (maxPriceProduct?.mrp) {
      mp = maxPriceProduct.mrp;
      // setquickUpdatedMaxPrice(mp);
    }
  }

  function handleSort(e) {

    if (e.target.value == 0) {
      const sortedLowToHigh = [...productlist].sort((a, b) => {
        return parseInt(a.selling_price) - parseInt(b.selling_price);
      });
      setproductlist(sortedLowToHigh);
    } else if (e.target.value == 1) {
      const sortedHightoLow = [...productlist].sort((a, b) => {
        return parseInt(b.selling_price) - parseInt(a.selling_price);
      });

      setproductlist(sortedHightoLow);
    } else {
      getproductlist();
    }
  }

  const performSearch = async (query) => {
    const trimmedQuery = (query !== undefined && query !== null ? String(query) : "").trim();
    if (!trimmedQuery) {
      getproductlist();
      setNoproducts(false);
      return;
    }
    startLoading();
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/snp/products/search`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        params: {
          name: trimmedQuery,
          seller_id: current_sellerid,
        },
      });
      if (data) {
        const results = Array.isArray(data?.data) ? data.data : [];
        setproductlist(results);
        setItemOffset(0);
        if (results.length < 1) {
          setNoproducts(true);
        } else {
          setNoproducts(false);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      stopLoading();
    }
  };

  function searchHandler(e) {
    const rawVal = e?.target?.value ?? "";
    const cleanedVal = rawVal.trimStart();
    const prevTrimmed = searchValue.trim();
    const newTrimmed = cleanedVal.trim();

    setsearchValue(cleanedVal);

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (!newTrimmed) {
      if (prevTrimmed !== "") {
        getproductlist();
        setNoproducts(false);
      }
      return;
    }

    searchTimeoutRef.current = setTimeout(() => {
      performSearch(newTrimmed);
    }, 300);
  }

  async function searchResult(e) {
    if (e.key === "Enter") {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      const trimmed = searchValue.trim();
      if (!trimmed) {
        return;
      }
      performSearch(trimmed);
    }
  }

  //---------------------------------------------- code  for pagination------------------------------------------------
  const [itemCheckboxes, setItemCheckboxes] = useState({});
  const [updatingStatusId, setUpdatingStatusId] = useState(null);

  useEffect(() => {
    const checkboxes = {};
    productlist.forEach((item) => {
      checkboxes[item.id] = item.status;
    });
    setItemCheckboxes(checkboxes);
  }, [productlist]);

  const itemsPerPage = 20;
  const [itemOffset, setItemOffset] = useState(0);

  const [currentItems, setcurrentItems] = useState([]);
  console.log("currentItemscurrentItems", currentItems)

  useEffect(() => {
    let z = productlist.slice(itemOffset, itemOffset + itemsPerPage);
    setcurrentItems([...z]);
  }, [productlist, itemOffset]);

  const pageCount = Math.ceil(productlist.length / itemsPerPage);

  const handlePageClick = (event) => {
    window.scrollTo(0, 0);
    const newOffset = (event.selected * itemsPerPage) % (productlist.length || 1);
    setItemOffset(newOffset);
  };

  //---------------------------------------------- code for pagination------------------------------------------------

  function updateProductList(productList) {
    setproductlist(productList)
  }

  const exportToExcel = async () => {
    startLoading();
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/allproductexport`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
      })
      console.log(data)
      const headers = Object.keys(data.message[0]);
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(data.message, { header: headers });
      XLSX.utils.book_append_sheet(wb, ws, 'Orders');
      const fileName = `seller_instoreProducts.xlsx`;
      XLSX.writeFile(wb, fileName);
      toast.success("Products Exported Successfully")
    } catch (err) {
      toast.error("Server Error, please try later!")
    } finally {
      stopLoading();
    }
  };


  const exportToExceldata = async () => {
    startLoading();
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/shopify/export-products`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
      })
      console.log(data)
      const headers = Object.keys(data.message[0]);
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(data.message, { header: headers });
      XLSX.utils.book_append_sheet(wb, ws, 'Orders');
      const fileName = `seller_instoreProducts.xlsx`;
      XLSX.writeFile(wb, fileName);
      toast.success("Products Exported Successfully")
    } catch (err) {
      toast.error("Server Error, please try later!")
    } finally {
      stopLoading();
    }
  };



  const handleImport = async () => {
    startLoading();
    // console.log(file)
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      complete: ({ data }) => {
        console.log(data)

        let x = data.map(item => {
          return {
            reference_id: item.reference_id,
            position: item?.position,
            selling_price: item?.selling_price
          }
        })
        sendDataToDb(x)
      },
    });
  };


  async function sendDataToDb(jsonData) {
    startLoading();
    try {

      console.log(jsonData)
      let result = await axios({
        url: `${apiEndpoint}/updateprice`,
        method: 'POST',
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,

        },
        data: jsonData,

      })
      getproductlist();
    } catch (error) {
      toast.error("403 error !");
    } finally {
      stopLoading();
    }
  }


  async function syncPriceHandler() {
    startLoading();
    setsyncing(true)
    try {
      const data = await axios({
        url: `${baseNodeapiUrl}/shopify/sync`,
        method: "PUT",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
        data: {
          "seller_id": syncingData.seller_id,
          "price": syncingData.price.toString(),
          "inventory": syncingData.inventory.toString(),
          "sku": syncingData.sku.toString(),
          "title": syncingData.title.toString(),
          "weight": syncingData.weight.toString()
        }

      })
      if (data.status == 200 && data.data.status == 200) {
        toast.success("Product Synced Successfully");
        setAlertOpen(false);
        setsyncing(false)
        getproductlist();
        setsyncingData({
          seller_id: current_sellerid.toString(),
          price: false,
          inventory: false,
          sku: false,
          title: false,
          weight: false
        })
      } else {
        toast.error("Something Went Wrong")
        setsyncing(true)
      }
    } catch (err) {
      console.log(err)
      setsyncing(true)
    } finally {
      stopLoading();
    }
  }


  function syncCheckHandler(e) {
    const { name } = e.target;
    console.log(name)
    console.log(e.target.value)
    setsyncingData((prev) => {
      return {
        ...prev, [name]: !prev[name]
      }
    })
  }


  async function deleteProductHandler(item) {
    startLoading();
    try {
      const data = await axios({
        url: `${apiEndpoint}/deleteVarNonPro`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
        data: {
          id: item.id,
          "has_variations": item.has_variations,
        }

      })
      if (data.status === 200) {
        toast.success("Product Deleted Successfully");
        getproductlist();
        handleShipementModalClose()
      } else {
        toast.error("Something Went Wrong")

      }
    } catch (err) {
      console.log(err)
      toast.error("Something Went Wrong")
    } finally {
      stopLoading();
    }
  }

  async function bulkdeleteHandler(item) {
    startLoading();
    try {
      const data = await axios({
        url: `${apiEndpoint}/bulk_delete`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
        data: selectedBox

      })
      if (data.status === 200) {
        toast.success("Selected Product Deleted!");
        getproductlist();
        handleShipementModalClose()
      } else {
        toast.error("Something Went Wrong");
      }
    } catch (err) {
      console.log(err)
      toast.error("Something Went Wrong")
    } finally {
      stopLoading();
    }
  }

  function handleShipementModalClose() {
    setConfirmDeleteModalOpen(false);
    setConfirmDeleteModalOpen(null)
  }
  const [selectedBox, setselectedBox] = useState([])
  function checkHandler(row) {
    console.log("dhadha", row.id);
    let hasId = selectedBox.some((item) => item == row.id)
    if (!hasId) {
      setselectedBox((prev) => {
        return [...prev, row.id]
      })
    } else {
      setselectedBox((prev) => {
        return prev.filter((item) => item !== row.id)
      })
    }

  }
  const [QRModalOpen, setQRModalOpen] = useState({
    openstatus: false,
    value: "",
    isLoading: false
  });
  function handleQRModalClose() {
    setQRModalOpen({ ...QRModalOpen, openstatus: false })
  }
  async function getQRHandler(item) {
    startLoading();
    let ProviderId = decoded?.data?.seller_data?.provider_id

    setQRModalOpen({ ...QRModalOpen, openstatus: true, isLoading: true })

    try {
      const data = await axios({
        url: `${baseNodeapiUrl}/api/product_qr_Code`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
        data: {
          "id": ProviderId,
          "descriptor_name": item?.name,
          "location_id": ProviderId,
          "bppId": "prod-sellerapp.shiprocket.com"
        }

      })
      setQRModalOpen({ openstatus: true, value: data.data.data, isLoading: false })
    } catch (err) {
      setQRModalOpen({ ...QRModalOpen, openstatus: false, isLoading: false })
      toast.error("Error in getting QR, please try later!")
    } finally {
      stopLoading();
    }
  }
  const qrRef = useRef(null);
  const handleDownload = () => {
    if (qrRef.current) {
      toPng(qrRef.current)
        .then((dataUrl) => {
          const link = document.createElement('a');
          link.href = dataUrl;
          link.download = 'qr-code.png';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((err) => {
          console.error('Failed to download QR code', err);
        });
    }
  };


  useEffect(() => {
    getproductlist();
  }, []);




  const [modalvisible, setModalvisible] = useState(false)
  const [showmessage, setShowmessage] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleOpenConfirm = () => setConfirmOpen(true);
  const handleCloseConfirm = () => setConfirmOpen(false);

  const handleOk = () => {
    setModalvisible(false)
  }
  const handleCancel = () => {
    setModalvisible(false)
  }


  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };


  const showConfirmation = () => {
    AntModal.confirm({
      title: "Are you a seller of this store?",
      okText: "Yes",
      okType: "primary", // makes the button blue by default
      cancelText: "No",
      centered: true,
      okButtonProps: {
        style: { backgroundColor: "#10B981", borderColor: "#10B981" }, // green color
      },
      onOk: async () => {
        // User clicked Yes → submit the file
        await handleSubmit();
      },
      onCancel: () => {
        // User clicked No → optional feedback
        toast.info("Upload cancelled.");
      },
    });
  };

  // Upload file API
  const handleSubmit = async () => {
    startLoading();
    if (!selectedFile) {
      stopLoading();
      toast.error("No file selected!");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(
        `${apiEndpoint}/import-order-status`,

        formData,
        {
          headers:
          {
            "Content-Type": "multipart/form-data",
            "x-custom-authorization": `Bearer ${token}`

          },
        }
      );

      toast.success("File uploaded successfully!");
      setSelectedFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      setModalvisible(false);
      console.log(response.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to upload file.");
    } finally {
      stopLoading();
    }
  };

  const [formodal, setformodal] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [updateType, setUpdateType] = useState(null);



  const resetSelectedFields = () => {
    setSelectedFields({
      name: false,
      mrp: false,
      selling_price: false,
      tax_included_price: false,
      quantity: false,
      description: false,
      short_description: false,
      image: false,
      reference_id: false
    });
  };



  const [selectedFields, setSelectedFields] = useState({
    name: false,
    mrp: false,
    selling_price: false,
    short_description: false,
    description: false,
    quantity: false,
    image: false,
    tax_included_price: false,
    reference_id: false
  });

  const showCustomModal = (item) => {
    // alert(Id)
    setSelectedFields({
      name: false,
      mrp: false,
      selling_price: false,
      reference_id: false,
      tax_included_price: false,
      description: false
    });
    setSelectedProduct(item);
    setformodal(true);
  }
  const handleCheckbox = (e) => {
    const names = e.target.name.split(","); // split into multiple field names
    const updatedFields = { ...selectedFields };

    names.forEach(name => {
      updatedFields[name] = e.target.checked; // set each field individually
    });

    setSelectedFields(updatedFields);
  };

  console.log("selectedFields===>", selectedFields)



  const sendUpdate = async () => {
    startLoading();
    if (updateType === "single" && !selectedProduct) {
      toast.error("No product selected");
      return;
    }

    const selectedAttributes = Object.keys(selectedFields).filter(
      (key) => selectedFields[key] === true
    );

    if (selectedAttributes.length === 0) {
      toast.error("Select at least one field");
      return;
    }

    const attributes_to_be_update = selectedAttributes.filter(
      (attr) => attr !== "reference_id"
    );

    const product_id = updateType === "single"
      ? [selectedProduct.reference_id]
      : [];

    const payload = {
      product_id,
      attributes_to_be_update
    };

    console.log("Final Payload →", payload);

    try {
      const response = await axios.post(`${apiEndpoint}/update-product`, payload, {
        headers: {
          "Content-Type": "application/json",
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        }
      });
      toast.success("Product updated successfully!");
      setformodal(false);
    } catch (error) {
      console.log("Update Failed →", error);
      toast.error("Failed to update product");
    } finally {
      stopLoading();
    }
  };

  const handlebuttonapi = async () => {
    startLoading();
    try {
      const res = await axios.post(
        `${apiEndpoint}/add-shopify-var-product`,
        {
          ondc: true,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`

          },
        }
      );

      console.log(res.data);
      toast.success("Product Inserted successfully")
    } catch (error) {
      console.error(error);
    } finally {
      stopLoading();
    }
  };

  const menuOptions = [

    {
      key: '1',
      label: (
        <div>
          <span onClick={() => setTimeout(() => {
            exportToExcel()
          }, 2000)}>Export Data</span>

        </div>
      ),
    },
    {
      key: '2',
      label: (

        <div>
          <span
            onClick={() => handlebuttonapi()}
            style={{ height: "32px" }}>
            Sync Shopify Products
          </span>
        </div>
      ),
    },
    {
      key: '3',
      label: (

        <div>
          <span
            onClick={() => {
              setUpdateType("all");
              setSelectedProduct(null);
              resetSelectedFields();
              setformodal(true);
            }}
            style={{ height: "32px" }}>
            Update All Products
          </span>
        </div>
      ),
    },
  ];

  const handleExportProductCsv = async () => {
    try {
      setIsExporting(true);
      const token = sessionStorage.getItem("token");
      const response = await axios({
        url: `${apiEndpoint}/snp/download/product-csv`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${token}`,
        },
        responseType: "blob",
      });

      // Check if response is actually a JSON error message (e.g. status 200 with error JSON blob)
      if (response.data instanceof Blob) {
        const text = await response.data.text();
        try {
          const parsed = JSON.parse(text);
          if (parsed?.status === false || parsed?.message) {
            toast.error(parsed.message || "No products found for this seller");
            return;
          }
        } catch (_) {
          // Valid binary CSV file, proceed to download
        }
      } else if (response.data && typeof response.data === "object" && response.data.status === false) {
        toast.error(response.data.message || "No products found for this seller");
        return;
      }

      const contentType = response.headers?.["content-type"] || "";
      const blob = new Blob([response.data], { type: contentType || "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `products_export.csv`);
      document.body.appendChild(link);
      link.click();
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
      window.URL.revokeObjectURL(url);
      toast.success("Product sheet exported successfully!");
    } catch (error) {
      console.error("Export product CSV error:", error);
      let errorMsg = "Failed to download product CSV";
      try {
        if (error?.response?.data instanceof Blob) {
          const errText = await error.response.data.text();
          const errJson = JSON.parse(errText);
          errorMsg = errJson?.message || errJson?.error || errText || errorMsg;
        } else if (error?.response?.data?.message) {
          errorMsg = error.response.data.message;
        } else if (error?.response?.data?.error) {
          errorMsg = error.response.data.error;
        } else if (error?.message) {
          errorMsg = error.message;
        }
      } catch (_) { }
      toast.error(errorMsg);
    } finally {
      setIsExporting(false);
    }
  };

  const handleCloseBulkUpdateModal = () => {
    setBulkUpdateModalOpen(false);
    setBulkUpdateFile(null);
    const fileInput = document.getElementById("bulkUpdateFileInput");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const handleBulkUpdateProducts = async () => {
    if (!bulkUpdateFile) {
      toast.error("Please select a CSV or Excel file first!");
      return;
    }

    try {
      setIsBulkUpdating(true);
      const token = sessionStorage.getItem("token")
      const formData = new FormData();
      formData.append("file", bulkUpdateFile);

      const response = await axios({
        method: "PUT",
        url: `${apiEndpoint}/snp/products/update-bulk`,
        data: formData,
        headers: {
          "x-custom-authorization": `Bearer ${token}`,
        },
      });

      if (response?.data?.success || response?.data?.status === 200 || response?.data?.status === true) {
        toast.success(response?.data?.message || "Products updated in bulk successfully!");
        handleCloseBulkUpdateModal();
        getproductlist();
      } else {
        toast.error(response?.data?.message || "Failed to update bulk products");
      }
    } catch (error) {
      console.error("Bulk update error:", error);
      toast.error(error?.response?.data?.message || error?.message || "Bulk update failed");
    } finally {
      setIsBulkUpdating(false);
    }
  };

  return (
    <ThemeMaker>
      <>
        <div className="row mx-auto p-3 position-relative" style={{ minHeight: "80vh" }}>
          <div className="card shadow-sm border p-4 w-100 mb-3" style={{ borderRadius: "20px", borderColor: "#E5E7EB", backgroundColor: "#ffffff", boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)", position: "sticky", top: "10px", zIndex: 30 }}>
            <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: "15px" }}>
              <h4 className="font-weight-bold m-0" style={{ color: "#0F172A", fontSize: "24px" }}>
                In-Store Catalog
              </h4>

              <div className="d-flex align-items-center flex-wrap" style={{ gap: "12px" }}>
                <div
                  className="d-flex align-items-center"
                  style={{
                    border: "1.5px solid #F97316",
                    borderRadius: "10px",
                    height: "44px",
                    padding: "0 14px",
                    backgroundColor: "#FFFFFF",
                    boxSizing: "border-box",
                  }}
                >
                  <i className="fas fa-search mr-2" style={{ fontSize: "14px", color: "#F97316" }}></i>
                  <input
                    type="search"
                    name="name"
                    placeholder="Search Product..."
                    className="border-0 bg-transparent text-dark"
                    value={searchValue}
                    onChange={searchHandler}
                    onKeyDown={searchResult}
                    onSearch={searchHandler}
                    style={{ outline: "none", fontSize: "14px", width: "190px", padding: 0 }}
                  />
                </div>

                <button
                  className="btn font-weight-bold d-inline-flex align-items-center justify-content-center"
                  style={{
                    borderRadius: "10px",
                    height: "44px",
                    padding: "0 18px",
                    fontSize: "14px",
                    gap: "8px",
                    border: "1.5px solid #F97316",
                    color: "#F97316",
                    backgroundColor: "#FFF7ED",
                    boxSizing: "border-box",
                    cursor: "pointer",
                  }}
                  onClick={() => setBulkUpdateModalOpen(true)}
                >
                  <i className="fas fa-edit" style={{ color: "#F97316", fontSize: "14px" }}></i>
                  <span>Bulk Update</span>
                </button>

                <button
                  className="btn font-weight-bold d-inline-flex align-items-center justify-content-center text-white"
                  style={{
                    backgroundColor: "#F97316",
                    borderColor: "#F97316",
                    border: "1.5px solid #F97316",
                    borderRadius: "10px",
                    height: "44px",
                    padding: "0 18px",
                    fontSize: "14px",
                    gap: "8px",
                    boxSizing: "border-box",
                    cursor: isExporting ? "not-allowed" : "pointer",
                    opacity: isExporting ? 0.8 : 1,
                  }}
                  onClick={handleExportProductCsv}
                  disabled={isExporting}
                >
                  <i className={isExporting ? "fas fa-spinner fa-spin" : "fas fa-file-excel"} style={{ fontSize: "14px" }}></i>
                  <span>{isExporting ? "Exporting..." : "Export Excel"}</span>
                </button>

                {/* <Dropdown menu={{ items: menuOptions }} placement="bottomRight">
                  <BsThreeDotsVertical style={{ fontSize: "22px", cursor: "pointer", color: "#0F172A" }} />
                </Dropdown> */}
              </div>
            </div>
          </div>

          {selectedBox.length > 0 ? <div className="d-flex w-100 justify-content-start mb-2" style={{ gap: "10px" }}>
            <span className="functionalButtons" onClick={() => {
              let z = productlist.filter(item => item);
              let m = z.map((item) => item?.id);
              setselectedBox(m)
            }} >Select All</span>
            <span className="functionalButtons" onClick={() => setselectedBox([])} >Clear</span>
          </div> : null}

          {/* -------------------------------------------- product mapping start ----------------------------- */}
          {productisLoading ? (
            <div className="card shadow-sm w-100 p-5 mt-2 d-flex flex-column align-items-center justify-content-center" style={{ borderRadius: "16px", border: "1px solid #E5E7EB", backgroundColor: "#FFFFFF", minHeight: "360px" }}>
              <div className="spinner-border" role="status" style={{ width: "3.2rem", height: "3.2rem", borderWidth: "3.5px", color: "#F97316" }}>
                <span className="sr-only">Loading products...</span>
              </div>
              <p className="mt-3 mb-0" style={{ fontSize: "15px", fontWeight: "600", color: "#475569" }}>
                Loading products, please wait...
              </p>
            </div>
          ) : !noproducts ? (
            <div className="table-responsive w-100 mt-2 card shadow-sm p-0" style={{ borderRadius: "16px", border: "1px solid #E5E7EB", overflowY: "auto", maxHeight: "calc(100vh - 250px)", minHeight: "auto", backgroundColor: "#FFFFFF" }}>
              <table className="table custom-table align-middle mb-0" style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
                <thead style={{ backgroundColor: "#F8FAFC", borderBottom: "2px solid #E2E8F0", position: "sticky", top: 0, zIndex: 10 }}>
                  <tr>
                    {/* <th style={{ width: "40px", textAlign: "center", padding: "12px" }}> */}
                    {/* <input
                        type="checkbox"
                        checked={selectedBox.length > 0 && selectedBox.length === currentItems.length}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setselectedBox(currentItems.map((item) => item.id));
                          } else {
                            setselectedBox([]);
                          }
                        }}
                      /> */}
                    {/* </th> */}
                    <th style={{ fontWeight: "700", color: "#334155", padding: "12px" }}>ID</th>
                    <th style={{ fontWeight: "700", color: "#334155", padding: "12px" }}>Image</th>
                    <th style={{ fontWeight: "700", color: "#334155", padding: "12px" }}>Product Name</th>
                    <th style={{ fontWeight: "700", color: "#334155", padding: "12px" }}>SKU / Ref ID</th>
                    {/* <th style={{ fontWeight: "700", color: "#334155", padding: "12px" }}>Category</th> */}
                    <th style={{ fontWeight: "700", color: "#334155", padding: "12px" }}>Selling Price</th>
                    {/* <th style={{ fontWeight: "700", color: "#334155", padding: "12px" }}>MRP</th> */}

                    <th style={{ fontWeight: "700", color: "#334155", padding: "12px" }}>Variants</th>
                    <th style={{ fontWeight: "700", color: "#334155", padding: "12px 16px", minWidth: "130px", width: "130px" }}>Status</th>
                    <th style={{ fontWeight: "700", color: "#334155", textAlign: "center", padding: "12px" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems?.map((item) => {
                    const otherOptions = [
                      {
                        key: '0',
                        label: <strong style={{ color: "#555" }}>{item?.name} (ID: {item?.id})</strong>,
                        disabled: true,
                      },
                      {
                        key: '1',
                        label: (
                          <Link to={`/createproduct?productId=${item.id}&q=${item?.variants?.length > 0 ? "true" : "false"}`}>
                            <span style={{ color: "black" }}>Edit Product</span>
                          </Link>
                        ),
                      },
                      {
                        key: '2',
                        label: (
                          <span onClick={() => getQRHandler(item)} style={{ cursor: "pointer", color: "black" }}>
                            Get Product QR
                          </span>
                        ),
                      },
                      {
                        key: '3',
                        label: (
                          <span onClick={() => showCustomModal(item)} style={{ cursor: "pointer", color: "black" }}>
                            Update Attributes
                          </span>
                        ),
                      },
                      {
                        key: '4',
                        label: (
                          <div>
                            {item?.variants?.length > 0 ? (
                              <span
                                className="badge badge-info"
                                style={{ /* same styles */ }}
                                onClick={() => handleOpenVariantsModal(item?.id, item?.name, item)}
                                title="Click to view all variant details"
                              >
                                <i className="fas fa-layer-group" style={{ fontSize: "11px" }}></i>
                                {item.variants.length} {item.variants.length === 1 ? "Variant" : "Variants"}
                              </span>
                            ) : (
                              <span style={{ color: "gray" }}>No Variants</span>
                            )}
                          </div>
                        ),
                      },
                      {
                        key: '5',
                        label: (
                          <span
                            onClick={() => {
                              setProductToDelete(item);
                              setConfirmDeleteModalOpen(true);
                            }}
                            style={{ color: "red", cursor: "pointer" }}
                          >
                            Delete Product
                          </span>
                        ),
                      },
                    ];

                    const imgSrc = item?.image
                    const sellingPrice = item?.variants?.[0]?.price?.selling_price ?? item?.selling_price ?? "-";
                    const mrpPrice = item?.variants?.[0]?.price?.mrp ?? item?.mrp ?? "-";
                    const totalQty = item?.available_qty !== undefined && item?.available_qty !== null && item?.available_qty !== ""
                      ? Number(item.available_qty)
                      : (item?.variants && item.variants.length > 0
                        ? item.variants.reduce((sum, v) => {
                          const vSum = Array.isArray(v?.inventories) && v.inventories.length > 0
                            ? v.inventories.reduce((s, inv) => s + (Number(inv.available_qty ?? inv.quantity ?? 0)), 0)
                            : Number(v?.available_qty ?? v?.quantity ?? 0);
                          return sum + vSum;
                        }, 0)
                        : (Number(item?.quantity ?? 0)));
                    const refId = item?.reference_id || item?.variants?.[0]?.sku || "N/A";

                    return (
                      <tr key={item?.id} style={{ borderBottom: "1px solid #F1F5F9" }}>
                        {/* <td style={{ textAlign: "center", padding: "12px" }}>
                          <input
                            type="checkbox"
                            checked={selectedBox.includes(item.id)}
                            onChange={() => checkHandler(item)}
                          />
                        </td> */}
                        <td style={{ fontWeight: "600", color: "#475569", padding: "12px" }}>{item?.id}</td>
                        <td style={{ padding: "12px" }}>
                          <div style={{ width: "48px", height: "48px", borderRadius: "8px", overflow: "hidden", backgroundColor: "#F8FAFC", border: "1px solid #E2E8F0", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            {imgSrc ? (
                              <img
                                src={imgSrc}
                                alt={item?.name || "Product"}
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = 'none';
                                  if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
                                }}
                              />
                            ) : null}
                            <div className="align-items-center justify-content-center w-100 h-100 text-muted" style={{ display: imgSrc ? 'none' : 'flex' }}>
                              <i className="fas fa-box" style={{ fontSize: "16px", color: "#CBD5E1" }}></i>
                            </div>
                          </div>
                        </td>
                        <td style={{ padding: "12px" }}>
                          <div style={{ fontWeight: "600", color: "#0F172A", maxWidth: "250px" }} title={item?.name}>
                            {item?.name}
                          </div>
                        </td>
                        <td style={{ color: "#64748B", fontSize: "12px", padding: "12px" }}>{refId}</td>
                        {/* <td style={{ color: "#475569", padding: "12px" }}>{item?.cat_name || "N/A"}</td> */}
                        <td style={{ fontWeight: "700", color: "#F97316", padding: "12px" }}>
                          {sellingPrice !== "-" ? `Rs ${sellingPrice}` : "-"}
                        </td>
                        {/* <td style={{ textDecoration: mrpPrice !== "-" ? "line-through" : "none", color: "#94A3B8", padding: "12px" }}>
                          {mrpPrice !== "-" ? `Rs ${mrpPrice}` : "-"}
                        </td> */}
                        <td style={{ padding: "12px" }}>
                          {item?.variants?.length > 0 ? (
                            <span
                              className="badge badge-info"
                              style={{
                                padding: "6px 12px",
                                borderRadius: "8px",
                                cursor: "pointer",
                                fontSize: "12px",
                                fontWeight: 600,
                                backgroundColor: "#E0F2FE",
                                color: "#0369A1",
                                border: "1px solid #BAE6FD",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "5px",
                                transition: "all 0.2s ease"
                              }}
                              onClick={() => handleOpenVariantsModal(item?.id, item?.name, item)}
                              title="Click to view all variant details"
                            >
                              <i className="fas fa-layer-group" style={{ fontSize: "11px" }}></i>
                              {item.variants.length} {item.variants.length === 1 ? "Variant" : "Variants"}
                            </span>
                          ) : (
                            <span
                              className="badge badge-warning cursor-pointer"
                              style={{
                                padding: "6px 12px",
                                borderRadius: "8px",
                                cursor: "pointer",
                                fontSize: "12px",
                                fontWeight: 600,
                                backgroundColor: "#FEF3C7",
                                color: "#D97706",
                                border: "1px solid #FDE68A",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "5px",
                                transition: "all 0.2s ease"
                              }}
                              onClick={() => handleOpenVariantsModal(item?.id, item?.name, item)}
                              title="Click to add/manage variants for this product"
                            >
                              <i className="fas fa-plus-circle" style={{ fontSize: "11px" }}></i>
                              0 Variants (+ Add)
                            </span>
                          )}
                        </td>
                        <td style={{ padding: "12px 16px", minWidth: "130px", width: "130px", verticalAlign: "middle" }}>
                          {(() => {
                            const itemId = item?.id ?? item?.product_id;
                            const isCurrentItemLoading = Boolean(itemId && updatingStatusId && String(updatingStatusId) === String(itemId));
                            const currentStatus = itemCheckboxes[itemId] ?? item?.status;

                            const commonTagStyle = {
                              borderRadius: "12px",
                              minWidth: "90px",
                              height: "28px",
                              padding: "0 12px",
                              fontSize: "12px",
                              fontWeight: "600",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "6px",
                              margin: 0,
                              userSelect: "none",
                              boxSizing: "border-box",
                              transition: "all 0.2s ease",
                            };

                            return (
                              <span
                                onClick={async () => {
                                  if (!itemId || updatingStatusId) return;
                                  const isChecked = !currentStatus;
                                  setUpdatingStatusId(itemId);
                                  try {
                                    const { data } = await axios({
                                      url: `${apiEndpoint}/snp/products/change-status`,
                                      method: "PUT",
                                      headers: {
                                        "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                                        "Content-type": "application/json",
                                      },
                                      data: { product_id: Number(itemId), status: isChecked },
                                    });
                                    if (data?.status || data?.status === 200) {
                                      setItemCheckboxes((prev) => ({ ...prev, [itemId]: isChecked }));
                                      toast.success(data?.message || "Status updated successfully");
                                    } else {
                                      toast.error(data?.message || "Failed to update status");
                                    }
                                  } catch (error) {
                                    console.log(error);
                                    toast.error(error?.response?.data?.message || "Failed to update status");
                                  } finally {
                                    setUpdatingStatusId(null);
                                  }
                                }}
                                style={{
                                  display: "inline-block",
                                  cursor: isCurrentItemLoading ? "not-allowed" : "pointer",
                                }}
                                title={isCurrentItemLoading ? "Updating status..." : "Click to toggle status"}
                              >
                                {isCurrentItemLoading ? (
                                  <Tag
                                    color="blue"
                                    style={{
                                      ...commonTagStyle,
                                      cursor: "not-allowed",
                                    }}
                                  >
                                    <i className="fas fa-spinner fa-spin" style={{ fontSize: "10  px" }}></i>
                                    Updating..
                                  </Tag>
                                ) : currentStatus ? (
                                  <Tag
                                    color="green"
                                    style={{
                                      ...commonTagStyle,
                                      cursor: "pointer",
                                    }}
                                  >
                                    Active
                                  </Tag>
                                ) : (
                                  <Tag
                                    color="red"
                                    style={{
                                      ...commonTagStyle,
                                      cursor: "pointer",
                                    }}
                                  >
                                    Disabled
                                  </Tag>
                                )}
                              </span>
                            );
                          })()}
                        </td>
                        <td style={{ textAlign: "center", padding: "12px" }}>
                          <div className="d-flex align-items-center justify-content-center" style={{ gap: "6px" }}>
                            <Link to={`/createproduct?productId=${item.id}&q=${item?.variants?.length > 0 ? "true" : "false"}`}>
                              <button className="btn btn-sm btn-outline-primary" style={{ padding: "4px 8px", borderRadius: "6px" }} title="Edit Product">
                                <i className="fas fa-edit"></i>
                              </button>
                            </Link>
                            {/* <button
                              className="btn btn-sm btn-outline-info"
                              style={{ padding: "4px 8px", borderRadius: "6px" }}
                              onClick={() => getQRHandler(item)}
                              title="Product QR"
                            >
                              <QrCode2Icon style={{ fontSize: "16px" }} />
                            </button> */}
                            {/* <button
                              className="btn btn-sm btn-outline-danger"
                              style={{ padding: "4px 8px", borderRadius: "6px" }}
                              onClick={() => {
                                setProductToDelete(item);
                                setConfirmDeleteModalOpen(true);
                              }}
                              title="Delete Product"
                            >
                              <DeleteIcon style={{ fontSize: "16px" }} />
                            </button> */}
                            {/* <Dropdown menu={{ items: otherOptions }} placement="bottomRight" trigger={['click']}>
                              <button className="btn btn-sm btn-light border" style={{ padding: "4px 6px", borderRadius: "6px" }}>
                                <BsThreeDotsVertical style={{ color: "#0F172A" }} />
                              </button>
                            </Dropdown> */}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="card shadow-sm w-100 p-5 mt-2 d-flex flex-column align-items-center justify-content-center" style={{ borderRadius: "16px", border: "1px solid #E5E7EB", backgroundColor: "#FFFFFF", minHeight: "260px" }}>
              <i className="fas fa-box-open mb-3" style={{ fontSize: "40px", color: "#CBD5E1" }}></i>
              <p className="mb-0" style={{ fontSize: "15px", color: "#64748B", fontWeight: "600" }}>
                No products available
              </p>
            </div>
          )}

          {/* -------------------------------------------- product mapping end ---------------------------------------- */}

          {/* -------------------------------------------- pagination start ---------------------------------------- */}

          {!productisLoading && (
            <div className='pagination_main mt-4 w-100 d-flex justify-content-center'>
              <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                onPageChange={handlePageClick}
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
                pageCount={pageCount}
                previousLabel="<"
                renderOnZeroPageCount={null}
                containerClassName="pagination mb-0"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
                activeLinkClassName="active"
              />
            </div>
          )}
          {/* -------------------------------------------- pagination end ---------------------------------------- */}
          {/* -------------------------------------------- pagination end ---------------------------------------- */}

        </div>

        <Modal open={open} onClose={handleSyncModalClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description"
        >
          <Box sx={syncmodalstyle}>
            <div className="mt-3 d-flex justify-content-end">
              {/* <button className="btn btn-primary" onClick={() => syncPriceHandler()}>Sync</button> */}
              <button className="btn btn-primary" onClick={Syncapi}>Product Sync</button>
            </div>
            <div>
              <p className="text-center" style={{ fontSize: "20px", color: 'black', fontWeight: "500" }}>Sync Inventory   </p>
            </div>

            <div>
              <div className="syncContainers mt-3">
                <input type="checkbox" name="price" checked={syncingData.price} onChange={syncCheckHandler} />  <label htmlFor="" className="p-0 m-0" >Update Price</label>
              </div>
              <div className="syncContainers mt-3" >
                <input type="checkbox" name="inventory" checked={syncingData.inventory} onChange={syncCheckHandler} />  <label htmlFor="" className="p-0 m-0" >Update Quantity</label>
              </div>
              <div className="syncContainers mt-3">
                <input type="checkbox" name="title" checked={syncingData.title} onChange={syncCheckHandler} />  <label htmlFor="" className="p-0 m-0" >Update Title</label>
              </div>
              <div className="syncContainers mt-3" >
                <input type="checkbox" disabled name="sku" checked={syncingData.sku} onChange={syncCheckHandler} />  <label htmlFor="" className="p-0 m-0" >Update SKU</label>
              </div>
              <div className="syncContainers mt-3">
                <input type="checkbox" disabled name="weight" checked={syncingData.weight} onChange={syncCheckHandler} />  <label htmlFor="" className="p-0 m-0">Update Weight</label>
              </div>
            </div>

            <div className="mt-3 d-flex justify-content-end">
              {/* <button className="btn btn-primary" onClick={() => syncPriceHandler()}>Sync</button> */}
              <button className="btn btn-primary" onClick={handleAlertOpen}>Sync</button>
            </div>


          </Box>
        </Modal>


        <Dialog
          open={Alertopen}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleAlertClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              On Clicking Agree, selected parameter will be updated for the products.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleAlertClose}>Disagree</Button>
            <button onClick={syncPriceHandler} className="btn btn-danger"> {syncing ? "Syncing" : "Agree"} </button>
          </DialogActions>
        </Dialog>


        {/* -------------------------------------DELETE CONFIRMATION MODAL-------------------------------------- */}
        <Modal
          open={ConfirmDeleteModalOpen}
          onClose={handleShipementModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle} className="col-md-4 ">

            <div className="modal-content " >
              <div className="modal-header p-2 d-flex align-items-center justify-content-between">
                <p className="modal-title genericlabel  " style={{ letterSpacing: "1px" }}>Delete Product..</p>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleShipementModalClose} /></span>
                </button>
              </div>
              <div className="modal-body">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <ReportProblemRoundedIcon style={{ fontSize: "40px", color: '#dd3737' }} />
                  <h5 style={{ fontWeight: '700' }}> Products once deleted can't be restored.
                    <h6 className="text-center font-weight-bold mt-1">Are you sure?</h6>
                  </h5>
                </div>
              </div>
              <div className="modal-footer">
                {selectedBox.length > 0 ? <button className="btn btn-danger" onClick={() => { bulkdeleteHandler() }} > Bulk Delete </button> : <button className="btn btn-danger" onClick={() => { deleteProductHandler(productToDelete) }} > Delete </button>}
              </div>
            </div>
          </Box>
        </Modal>

        {/* -------------------------------------QR MODAL-------------------------------------- */}
        <Modal
          open={QRModalOpen.openstatus}
          onClose={handleQRModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...modalStyle, width: 300 }} className="col-md-3 ">

            <div className="modal-content  position-relative" >
              <div className="modal-header p-2 d-flex align-items-center justify-content-between">
                <p className="modal-title genericlabel  " style={{ letterSpacing: "1px" }}>Product QR..</p>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span style={{ cursor: "pointer" }} ><CloseIcon onClick={() => setQRModalOpen({ ...QRModalOpen, openstatus: false, isLoading: false })} /></span>
                </button>
              </div>
              {QRModalOpen?.isLoading === false ? <div className="modal-body">
                <div className="d-flex flex-column justify-content-center align-items-center ">
                  <div ref={qrRef} className="p-3" style={{ background: "white" }}>
                    <QRCode
                      // size={100}
                      style={{
                        height: 'auto',
                        maxWidth: '100%',
                        width: '100%',
                      }}
                      value={QRModalOpen.value}
                    // viewBox="0 0 50 100"
                    />
                  </div>

                  <p className="genericlabel mt-2">Scan QR to check store.</p>
                  <DownloadForOfflineRoundedIcon onClick={handleDownload} style={{ fontSize: "40px", position: "absolute", bottom: "5px", right: "5px", color: "#105293", cursor: "pointer" }} titleAccess="Save QR" />

                </div>
              </div> : <p className="p-4 text-center">Loading...</p>}

            </div>
          </Box>
        </Modal>
        {/* -------------------------------------QR MODAL-------------------------------------- */}

        <AntModal style={{ height: "300px !Important", borderRadius: "10px" }}
          className="custom-left-modal"
          open={modalvisible}
          // onOk={handleOk}
          onCancel={handleCancel}
          width={320}
          mask={false}
          footer={null}
        >
          <div className="flex flex-col gap-4 text-center mt-4">
            <input
              type="file"
              accept=".csv"
              ref={fileInputRef}
              onChange={handleFileChange}
            />
            <div className="mt-4">
              <button
                className="btn btn-primary p-2 rounded" onClick={showConfirmation} disabled={!selectedFile}>
                Submit
              </button>
            </div>
          </div>



        </AntModal>

        {/* ----------------- Variants Details Modal ----------------- */}
        <AntModal
          open={variantsModalOpen}
          onCancel={() => setVariantsModalOpen(false)}
          zIndex={1050}
          footer={[

          ]}
          width={1180}
          centered
          title={
            <div className="d-flex align-items-center justify-content-between flex-wrap" style={{ gap: "10px", width: "100%", paddingRight: "24px" }}>
              <div className="d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
                <span style={{ fontSize: "18px", fontWeight: 700, color: "#0F172A" }}>
                  Product Variants
                </span>
                {selectedProductDetails?.name && (
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#1E293B",
                      backgroundColor: "#F1F5F9",
                      padding: "3px 12px",
                      borderRadius: "16px",
                      border: "1px solid #E2E8F0"
                    }}
                  >
                    {selectedProductDetails.name} (ID: #{selectedProductDetails.id})
                  </span>
                )}
                {selectedProductVariants.length > 0 && (
                  <span className="badge badge-info" style={{ borderRadius: "12px", fontSize: "12px", padding: "4px 10px" }}>
                    {selectedProductVariants.length} Variants
                  </span>
                )}
              </div>
              <button
                type="button"
                className="btn btn-sm btn-primary d-flex align-items-center shadow-sm"
                style={{
                  backgroundColor: "#F97316",
                  borderColor: "#F97316",
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "13px",
                  gap: "6px",
                  padding: "6px 16px"
                }}
                onClick={() => handleOpenCreateVariantModal(
                  selectedProductDetails?.product_type_id || selectedProductVariants?.[0]?.product_type_id || creatvariant,
                  selectedProductDetails?.product_id || selectedProductDetails?.id || selectedProductVariants?.[0]?.product_id
                )}
              >
                + Create Variation
              </button>
            </div>
          }
        >
          {variantsModalLoading ? (
            <div className="d-flex flex-column align-items-center justify-content-center py-5" style={{ minHeight: "220px", gap: "12px" }}>
              <Circularprogress />
              <span style={{ color: "#64748B", fontSize: "14px", fontWeight: 500 }}>
                Loading variant details...
              </span>
            </div>
          ) : selectedProductVariants && selectedProductVariants.length > 0 ? (
            <div style={{ maxHeight: "65vh", overflowY: "auto", padding: "4px" }}>
              <div className="table-responsive">
                <table className="table table-bordered table-hover mb-0" style={{ fontSize: "13px", borderCollapse: "separate", borderSpacing: 0, borderRadius: "10px", overflow: "hidden" }}>
                  <thead style={{ backgroundColor: "#F8FAFC", color: "#334155", fontWeight: 700 }}>
                    <tr>
                      <th style={{ padding: "10px", borderBottom: "2px solid #E2E8F0" }}>Sr. no.</th>
                      <th style={{ padding: "10px", borderBottom: "2px solid #E2E8F0" }}>Image</th>
                      <th style={{ padding: "10px", borderBottom: "2px solid #E2E8F0" }}>SKU / ID</th>
                      <th style={{ padding: "10px", borderBottom: "2px solid #E2E8F0" }}>Attributes</th>
                      <th style={{ padding: "10px", borderBottom: "2px solid #E2E8F0" }}>MRP</th>
                      <th style={{ padding: "10px", borderBottom: "2px solid #E2E8F0" }}>Selling Price</th>
                      <th style={{ padding: "10px", borderBottom: "2px solid #E2E8F0" }}>Available Qty</th>
                      <th style={{ padding: "10px", borderBottom: "2px solid #E2E8F0" }}>Status</th>
                      <th style={{ padding: "10px", borderBottom: "2px solid #E2E8F0", textAlign: "center" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedProductVariants.map((variant, idx) => {
                      const varImg = Array.isArray(variant.image)
                        ? variant.image[0]
                        : variant.image
                          ? variant.image.split(",")[0]
                          : null;
                      const varMrp = variant?.price?.mrp ?? variant?.mrp ?? "-";
                      const varSelling = variant?.price?.selling_price ?? variant?.selling_price ?? "-";
                      const varQty = variant?.available_qty !== undefined && variant?.available_qty !== null && variant?.available_qty !== ""
                        ? Number(variant.available_qty)
                        : (Array.isArray(variant?.inventories) && variant.inventories.length > 0
                          ? variant.inventories.reduce((sum, inv) => sum + (Number(inv.available_qty ?? inv.quantity ?? 0)), 0)
                          : Number(variant?.quantity ?? 0));
                      const isActive = variant?.status === true || variant?.status === 1 || variant?.status === "1" || variant?.status === "active";

                      // Resolve attributes list from features or attributes
                      const attrList = [];
                      const featObj = variant?.features && typeof variant.features === "object" && !Array.isArray(variant.features)
                        ? variant.features
                        : (typeof variant?.features === "string" ? (() => { try { return JSON.parse(variant.features); } catch (e) { return null; } })() : null);

                      if (featObj && Object.keys(featObj).length > 0) {
                        Object.entries(featObj).forEach(([k, v]) => {
                          if (v !== null && v !== undefined && String(v).trim() !== "") {
                            attrList.push({ name: k, value: String(v) });
                          }
                        });
                      } else if (Array.isArray(variant?.attributes) && variant.attributes.length > 0) {
                        variant.attributes.forEach(attr => {
                          const name = attr?.attribute_name || attr?.name || "";
                          const value = attr?.attribute_value ?? attr?.value ?? "";
                          if (name && value !== "") {
                            attrList.push({ name, value: String(value) });
                          }
                        });
                      } else if (variant?.attributes && typeof variant.attributes === "object" && !Array.isArray(variant.attributes)) {
                        Object.entries(variant.attributes).forEach(([k, v]) => {
                          if (v !== null && v !== undefined && String(v).trim() !== "") {
                            attrList.push({ name: k, value: String(v) });
                          }
                        });
                      }

                      return (
                        <tr key={variant?.id || idx}>
                          <td style={{ padding: "10px", fontWeight: 600, color: "#64748B" }}>{idx + 1}</td>
                          <td style={{ padding: "10px" }}>
                            <div
                              style={{
                                width: "44px",
                                height: "44px",
                                borderRadius: "8px",
                                overflow: "hidden",
                                backgroundColor: "#F1F5F9",
                                border: "1px solid #E2E8F0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {varImg ? (
                                <img
                                  src={varImg}
                                  alt={variant?.sku || "Variant"}
                                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.style.display = "none";
                                    if (e.target.nextSibling) e.target.nextSibling.style.display = "flex";
                                  }}
                                />
                              ) : null}
                              <div className="align-items-center justify-content-center w-100 h-100 text-muted" style={{ display: varImg ? "none" : "flex" }}>
                                <i className="fas fa-image" style={{ fontSize: "14px", color: "#CBD5E1" }}></i>
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: "10px" }}>
                            <div style={{ fontWeight: 600, color: "#0F172A" }}>
                              {variant?.sku || `Variant #${variant?.id || idx + 1}`}
                            </div>
                            {variant?.gtin && (
                              <small style={{ color: "#64748B" }}>GTIN: {variant.gtin}</small>
                            )}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {attrList.length > 0 ? (
                              <div className="d-flex flex-wrap" style={{ gap: "6px", maxWidth: "340px" }}>
                                {attrList.map((attr, aIdx) => (
                                  <span
                                    key={aIdx}
                                    style={{
                                      fontSize: "11.5px",
                                      padding: "3px 8px",
                                      backgroundColor: "#EFF6FF",
                                      color: "#1D4ED8",
                                      borderRadius: "6px",
                                      border: "1px solid #DBEAFE",
                                      display: "inline-flex",
                                      alignItems: "center"
                                    }}
                                  >
                                    <strong style={{ color: "#1E40AF", marginRight: "4px" }}>{attr.name}:</strong> {attr.value}
                                  </span>
                                ))}
                              </div>
                            ) : (
                              <span className="text-muted" style={{ fontSize: "12px" }}>-</span>
                            )}
                          </td>
                          <td style={{ padding: "10px", color: "#64748B" }}>
                            {varMrp !== "-" ? `₹${varMrp}` : "-"}
                          </td>
                          <td style={{ padding: "10px", fontWeight: 700, color: "#F97316" }}>
                            {varSelling !== "-" ? `₹${varSelling}` : "-"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {Array.isArray(variant?.inventories) && variant.inventories.length > 0 ? (
                              <div className="d-flex flex-column" style={{ gap: "4px" }}>
                                {variant.inventories.map((inv, iIdx) => {
                                  const qty = Number(inv?.available_qty ?? inv?.quantity ?? 0);
                                  const whId = inv?.warehouse_id || inv?.id || "N/A";
                                  return (
                                    <div
                                      key={iIdx}
                                      className="d-inline-flex align-items-center"
                                      style={{
                                        padding: "3px 8px",
                                        borderRadius: "6px",
                                        fontSize: "11.5px",
                                        fontWeight: 600,
                                        backgroundColor: qty > 0 ? "#DCFCE7" : "#FEE2E2",
                                        color: qty > 0 ? "#15803D" : "#B91C1C",
                                        border: qty > 0 ? "1px solid #BBF7D0" : "1px solid #FECACA",
                                        whiteSpace: "nowrap"
                                      }}
                                    >
                                      <span style={{ opacity: 0.85, marginRight: "4px" }}>WH #{whId}:</span>
                                      <span>{qty} in stock</span>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <span
                                style={{
                                  padding: "3px 8px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  backgroundColor: Number(varQty) > 0 ? "#DCFCE7" : "#FEE2E2",
                                  color: Number(varQty) > 0 ? "#15803D" : "#B91C1C",
                                }}
                              >
                                {varQty} in stock
                              </span>
                            )}
                          </td>
                          <td style={{ padding: "10px" }}>
                            <span
                              className={`badge ${isActive ? "badge-success" : "badge-secondary"}`}
                              style={{ borderRadius: "6px", padding: "4px 8px" }}
                            >
                              {isActive ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td style={{ padding: "10px", textAlign: "center" }}>
                            <button
                              type="button"
                              className="btn btn-sm text-white font-weight-bold"
                              style={{
                                backgroundColor: "#F97316",
                                borderColor: "#F97316",
                                borderRadius: "6px",
                                fontSize: "12px",
                                padding: "4px 14px",
                                boxShadow: "0 2px 6px rgba(249, 115, 22, 0.25)",
                                cursor: "pointer"
                              }}
                              onClick={() => handleOpenEditVariantModal(variant?.id)}
                            >
                              <i className="fas fa-edit mr-1"></i> Edit
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="text-center py-5" style={{ color: "#64748B" }}>
              <i className="fas fa-box-open" style={{ fontSize: "36px", color: "#CBD5E1", marginBottom: "8px" }}></i>
              <p className="m-0" style={{ fontWeight: 600 }}>No variants details found for this product.</p>
            </div>
          )}
        </AntModal>

        {/* ----------------- Create / Edit Variation Sub-Modal ----------------- */}
        <AntModal
          open={createVariantModalOpen}
          onCancel={() => {
            setCreateVariantModalOpen(false);
            setIsVariantDetailsLoading(false);
          }}
          footer={null}
          width={860}
          centered
          zIndex={1060}
          title={
            <div className="d-flex align-items-center justify-content-between pr-3 py-1">
              <div className="d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
                <span style={{ fontSize: "17px", fontWeight: 700, color: "#0F172A" }}>
                  {editingVariantId ? "Edit Variation Details" : "Create New Variation"}
                </span>
                {newVariantForm.sku && !isVariantDetailsLoading ? (
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      color: "#F97316",
                      backgroundColor: "#FFF7ED",
                      border: "1px solid #FFEDD5",
                      padding: "2px 10px",
                      borderRadius: "12px"
                    }}
                  >
                    SKU: {newVariantForm.sku}
                  </span>
                ) : null}
              </div>
            </div>
          }
        >
          {isVariantDetailsLoading ? (
            <div
              className="d-flex flex-column align-items-center justify-content-center py-5 my-3"
              style={{
                minHeight: "360px",
                background: "linear-gradient(180deg, #FAFAFA 0%, #FFFFFF 100%)",
                borderRadius: "12px",
                border: "1px dashed #E2E8F0"
              }}
            >
              <div className="position-relative d-flex align-items-center justify-content-center mb-3">
                <div
                  className="spinner-border"
                  role="status"
                  style={{
                    width: "3.5rem",
                    height: "3.5rem",
                    borderWidth: "3.5px",
                    color: "#F97316",
                    borderColor: "#FFEDD5",
                    borderTopColor: "#F97316",
                  }}
                >
                  <span className="sr-only">Loading...</span>
                </div>
                <FiBox
                  style={{
                    position: "absolute",
                    fontSize: "20px",
                    color: "#F97316"
                  }}
                />
              </div>
              <h6 style={{ fontWeight: 700, color: "#0F172A", fontSize: "16px", marginBottom: "6px" }}>
                Fetching Variation Data...
              </h6>
              <p style={{ color: "#64748B", fontSize: "13px", margin: 0 }}>
                Please wait while we load the latest pricing, stock & attribute details.
              </p>
            </div>
          ) : (
            <form onSubmit={editingVariantId ? handleUpdateVariantSubmit : handleCreateVariantSubmit} className="pt-2">
              <div style={{ maxHeight: "74vh", overflowY: "auto", paddingRight: "6px" }}>

                {/* Card 1: Basic Identifiers & Pricing */}
                <div className="p-3 mb-3" style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #E2E8F0", boxShadow: "0 2px 6px rgba(15, 23, 42, 0.03)" }}>
                  <div className="d-flex align-items-center mb-3" style={{ gap: "8px" }}>
                    <FiInfo style={{ color: "#F97316", fontSize: "16px" }} />
                    <span style={{ fontSize: "13px", fontWeight: 700, color: "#0F172A" }}>Basic Information & Pricing</span>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        SKU Code <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.sku}
                        onChange={(e) => {
                          const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                          setNewVariantForm({ ...newVariantForm, sku: val });
                        }}
                        placeholder="Enter SKU Code"
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>HSN Code</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        maxLength={8}
                        value={newVariantForm.hsn}
                        onChange={(e) => {
                          const val = e.target.value.replace(/[^0-9]/g, "").trimStart();
                          setNewVariantForm({ ...newVariantForm, hsn: val });
                        }}
                        placeholder="Enter HSN Code"
                      />
                    </div>

                    <div className="col-md-6 mb-2">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        MRP (₹) <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.mrp}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val.length > 7) return;

                          if (!/^\d*\.?\d{0,2}$/.test(val)) return;

                          if (/^0\d/.test(val)) return;
                          if (Number(val) < 0) return;
                          setNewVariantForm({ ...newVariantForm, mrp: val });
                        }}
                        placeholder="Enter MRP"
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-2">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Selling Price (₹) <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        className={`form-control form-control-sm ${Number(newVariantForm.selling_price) > Number(newVariantForm.mrp) && Number(newVariantForm.mrp) > 0 ? "is-invalid border-danger" : ""}`}
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.selling_price}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val.length > 7) return;

                          if (!/^\d*\.?\d{0,2}$/.test(val)) return;

                          if (/^0\d/.test(val)) return;
                          if (Number(val) < 0) return;
                          setNewVariantForm({ ...newVariantForm, selling_price: val });
                        }}
                        placeholder="Enter Selling Price"
                        required
                      />
                      {Number(newVariantForm.selling_price) > Number(newVariantForm.mrp) && Number(newVariantForm.mrp) > 0 && (
                        <span className="text-danger tiny_size">Selling price cannot be greater than MRP!</span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Card 2: Warehouse Stock Allocation */}
                <div className="p-3 mb-3" style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #E2E8F0", boxShadow: "0 2px 6px rgba(15, 23, 42, 0.03)" }}>
                  <div className="d-flex align-items-center mb-3" style={{ gap: "8px" }}>
                    <FiBox style={{ color: "#F97316", fontSize: "16px" }} />
                    <span style={{ fontSize: "13px", fontWeight: 700, color: "#0F172A" }}>
                      Warehouse Inventory Allocation <span className="text-danger">*</span>
                    </span>
                  </div>

                  {/* Selected Warehouses Table */}
                  {Object.keys(variantWarehouses).some(id => variantWarehouses[id]) ? (
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span style={{ fontSize: "12px", fontWeight: 700, color: "#1E293B" }}>
                          Allocated Warehouses ({Object.keys(variantWarehouses).filter(id => variantWarehouses[id]).length})
                        </span>
                        <span style={{ fontSize: "11px", color: "#64748B" }}>
                          Edit available quantity per warehouse below
                        </span>
                      </div>
                      <div style={{ borderRadius: "8px", border: "1px solid #E2E8F0", backgroundColor: "#ffffff", overflow: "hidden" }}>
                        <table className="table table-sm table-bordered table-hover mb-0" style={{ fontSize: "12px", width: "100%" }}>
                          <thead style={{ backgroundColor: "#F8FAFC", color: "#334155" }}>
                            <tr>
                              <th style={{ width: "40px", textAlign: "center", padding: "8px" }}>#</th>
                              <th style={{ padding: "8px 12px" }}>Warehouse Name</th>
                              <th style={{ width: "140px", textAlign: "center", padding: "8px" }}>Available Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.keys(variantWarehouses)
                              .filter(whId => variantWarehouses[whId])
                              .map((whId, idx) => {
                                const matchedWh = warehouses?.find(w => String(w.id) === String(whId));
                                const currentQty = variantWarehouseQty[whId] !== undefined && variantWarehouseQty[whId] !== ""
                                  ? variantWarehouseQty[whId]
                                  : "0";

                                return (
                                  <tr key={whId}>
                                    <td style={{ textAlign: "center", verticalAlign: "middle", fontWeight: 600, color: "#64748B", padding: "8px" }}>
                                      {idx + 1}
                                    </td>
                                    <td style={{ verticalAlign: "middle", padding: "8px 12px" }}>
                                      <div style={{ fontWeight: 600, color: "#0F172A", fontSize: "12.5px" }}>
                                        {matchedWh?.warehouse_name || `Warehouse #${whId}`}
                                      </div>
                                      <div style={{ fontSize: "11px", color: "#64748B" }}>
                                        ID: #{whId}{matchedWh?.warehouse_code ? ` | Code: ${matchedWh.warehouse_code}` : ""}
                                      </div>
                                    </td>
                                    <td style={{ verticalAlign: "middle", textAlign: "center", padding: "6px 12px" }}>
                                      <input
                                        type="number"
                                        min="0"
                                        className="form-control form-control-sm text-center font-weight-bold"
                                        style={{ borderRadius: "6px", height: "32px", maxWidth: "110px", margin: "0 auto", fontSize: "12.5px" }}
                                        value={currentQty}
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          setVariantWarehouseQty(prev => ({ ...prev, [whId]: val }));
                                        }}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div className="p-3 text-center" style={{ backgroundColor: "#F8FAFC", borderRadius: "8px", border: "1px dashed #CBD5E1", color: "#64748B", fontSize: "12px" }}>
                      <FiBox style={{ fontSize: "18px", marginBottom: "4px", color: "#94A3B8" }} />
                      <div>No warehouses currently allocated to this variation.</div>
                    </div>
                  )}
                </div>

                {/* Card 3: Quantity & Measurement (UOM) */}
                <div className="p-3 mb-3" style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #E2E8F0", boxShadow: "0 2px 6px rgba(15, 23, 42, 0.03)" }}>
                  <div className="d-flex align-items-center mb-3" style={{ gap: "8px" }}>
                    <FiLayers style={{ color: "#F97316", fontSize: "16px" }} />
                    <span style={{ fontSize: "13px", fontWeight: 700, color: "#0F172A" }}>Quantity Limits & Measurement</span>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Min Quantity <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        min="1"
                        maxLength={3}
                        className={`form-control form-control-sm ${newVariantForm.min_quantity !== "" &&
                          newVariantForm.max_quantity !== "" &&
                          Number(newVariantForm.max_quantity) < Number(newVariantForm.min_quantity)
                          ? "is-invalid border-danger"
                          : ""
                          }`}
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.min_quantity}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E"].includes(e.key)) e.preventDefault();
                        }}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val.length > 6) return;
                          if (Number(val) < 0) return;
                          setNewVariantForm({ ...newVariantForm, min_quantity: val });
                        }}
                        placeholder="Enter Min Qty"
                        required
                      />
                      {newVariantForm.min_quantity !== "" &&
                        newVariantForm.max_quantity !== "" &&
                        Number(newVariantForm.max_quantity) < Number(newVariantForm.min_quantity) && (
                          <span className="text-danger mt-1 d-block" style={{ fontSize: "11px", fontWeight: 500 }}>
                            Min Quantity cannot be greater than Max Quantity!
                          </span>
                        )}
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Max Quantity <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        min="1"
                        maxLength={3}
                        className={`form-control form-control-sm ${newVariantForm.min_quantity !== "" &&
                          newVariantForm.max_quantity !== "" &&
                          Number(newVariantForm.max_quantity) < Number(newVariantForm.min_quantity)
                          ? "is-invalid border-danger"
                          : ""
                          }`}
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.max_quantity}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E"].includes(e.key)) e.preventDefault();
                        }}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val.length > 6) return;
                          if (Number(val) < 0) return;
                          setNewVariantForm({ ...newVariantForm, max_quantity: val });
                        }}
                        placeholder="Enter Max Qty"
                        required
                      />
                      {newVariantForm.min_quantity !== "" &&
                        newVariantForm.max_quantity !== "" &&
                        Number(newVariantForm.max_quantity) < Number(newVariantForm.min_quantity) && (
                          <span className="text-danger mt-1 d-block" style={{ fontSize: "11px", fontWeight: 500 }}>
                            Max Quantity must be greater than or equal to Min Quantity ({newVariantForm.min_quantity})!
                          </span>
                        )}
                    </div>

                    {/* <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Weight (kg) <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        step="any"
                        min="0"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.weights}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E"].includes(e.key)) e.preventDefault();
                        }}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (Number(val) < 0) return;
                          setNewVariantForm({ ...newVariantForm, weights: val, packing_weight: val });
                        }}
                        placeholder="Weight (e.g. 0.5)"
                        required
                      />
                    </div> */}

                    <div className="col-md-6 mb-2">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Unit of Measurement (UOM) <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.uom || ""}
                        onChange={(e) => setNewVariantForm({ ...newVariantForm, uom: e.target.value })}
                        required
                      >
                        <option value="">Select UOM...</option>
                        <option value="unit">Unit</option>
                        <option value="dozen">Dozen</option>
                        <option value="gram">Gram</option>
                        <option value="kilogram">Kilogram</option>
                        <option value="litre">Litre</option>
                        <option value="millilitre">Millilitre</option>
                        <option value="tonne">Tonne</option>
                      </select>
                    </div>

                    <div className="col-md-6 mb-2">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        UOM Value <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        step="any"
                        min="0.0001"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.uom_value}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E"].includes(e.key)) e.preventDefault();
                        }}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val.replace(".", "").length > 6) return;
                          if (Number(val) < 0) return;
                          setNewVariantForm({ ...newVariantForm, uom_value: val });
                        }}
                        placeholder="Enter UOM Value (e.g. 1)"
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Card 4: Pack & Packaging Dimensions */}
                <div className="p-3 mb-3" style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #E2E8F0", boxShadow: "0 2px 6px rgba(15, 23, 42, 0.03)" }}>
                  <div className="d-flex align-items-center mb-3" style={{ gap: "8px" }}>
                    <FiPackage style={{ color: "#F97316", fontSize: "16px" }} />
                    <span style={{ fontSize: "13px", fontWeight: 700, color: "#0F172A" }}>Pack & Packaging Dimensions</span>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Pack Set</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.pack_config_set}
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.trimStart();

                          value = value.replace(/[^0-9]/g, "");
                          if (value.length > 3) return;

                          setNewVariantForm({ ...newVariantForm, pack_config_set: value });
                        }}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E", "@", "#", "!", "$", "%"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pastedText = e.clipboardData.getData("text");
                          if (!/^\d*$/.test(pastedText)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Pack Set (e.g. 6)"
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Pack Case</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.pack_config_case}
                        onChange={(e) => {
                          let value = e.target.value.trimStart().replace(/[^0-9]/g, "");
                          if (value.length > 3) return;
                          setNewVariantForm({ ...newVariantForm, pack_config_case: value });
                        }}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E", "@", "#", "!", "$", "%", "*", "(", ")", "^", "&"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pastedText = e.clipboardData.getData("text");
                          if (!/^\d*$/.test(pastedText)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Pack Case (e.g. 12)"
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Pack Selling Unit</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.pack_config_selling_unit}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          let value = e.target.value.trimStart().replace(/[^0-9]/g, "");
                          if (value.length > 3) return;
                          setNewVariantForm({ ...newVariantForm, pack_config_selling_unit: value });
                        }}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E", "@", "#", "!", "$", "%", "*", "(", ")", "^", "&"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pastedText = e.clipboardData.getData("text");
                          if (!/^\d*$/.test(pastedText)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Selling Unit (e.g. 1)"
                      />
                    </div>

                    <div className="col-md-4 mb-2">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Height (cm)</label>
                      <input
                        type="number"
                        step="any"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.packing_height}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          let value = e.target.value.trimStart().replace(/[^0-9.]/g, "");
                          const parts = value.split(".");
                          if (parts.length > 2) value = parts[0] + "." + parts.slice(1).join("");
                          if (value.replace(".", "").length > 4) return;
                          setNewVariantForm({ ...newVariantForm, packing_height: value });
                        }}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E", "@", "#", "!", "$", "%", "*", "(", ")", "^", "&"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pastedText = e.clipboardData.getData("text");
                          if (!/^\d*\.?\d*$/.test(pastedText)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Height"
                      />
                    </div>

                    <div className="col-md-4 mb-2">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Length (cm)</label>
                      <input
                        type="number"
                        step="any"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.packing_length}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          let value = e.target.value.trimStart().replace(/[^0-9.]/g, "");
                          const parts = value.split(".");
                          if (parts.length > 2) value = parts[0] + "." + parts.slice(1).join("");
                          if (value.replace(".", "").length > 4) return;
                          setNewVariantForm({ ...newVariantForm, packing_length: value });
                        }}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E", "@", "#", "!", "$", "%", "*", "(", ")", "^", "&"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pastedText = e.clipboardData.getData("text");
                          if (!/^\d*\.?\d*$/.test(pastedText)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Length"
                      />
                    </div>

                    <div className="col-md-4 mb-2">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Breadth (cm)</label>
                      <input
                        type="number"
                        step="any"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.packing_breadth}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          let value = e.target.value.trimStart().replace(/[^0-9.]/g, "");
                          const parts = value.split(".");
                          if (parts.length > 2) value = parts[0] + "." + parts.slice(1).join("");
                          if (value.replace(".", "").length > 4) return;
                          setNewVariantForm({ ...newVariantForm, packing_breadth: value });
                        }}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E", "@", "#", "!", "$", "%", "*", "(", ")", "^", "&"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pastedText = e.clipboardData.getData("text");
                          if (!/^\d*\.?\d*$/.test(pastedText)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Breadth"
                      />
                    </div>

                    <div className="col-md-6 mb-2">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Packaging Weight (kg)</label>
                      <input
                        type="number"
                        step="any"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.packing_weight}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          let value = e.target.value.trimStart().replace(/[^0-9.]/g, "");
                          const parts = value.split(".");
                          if (parts.length > 2) value = parts[0] + "." + parts.slice(1).join("");
                          if (value.replace(".", "").length > 4) return;
                          setNewVariantForm({ ...newVariantForm, packing_weight: value, weights: value });
                        }}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E", "@", "#", "!", "$", "%", "*", "(", ")", "^", "&"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pastedText = e.clipboardData.getData("text");
                          if (!/^\d*\.?\d*$/.test(pastedText)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Packaging Weight"
                      />
                    </div>

                    <div className="col-md-6 mb-2">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Packing Price (₹)</label>
                      <input
                        type="number"
                        step="any"
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.packing_price}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          let value = e.target.value.trimStart().replace(/[^0-9.]/g, "");
                          const parts = value.split(".");
                          if (parts.length > 2) value = parts[0] + "." + parts.slice(1).join("");
                          if (value.replace(".", "").length > 4) return;
                          setNewVariantForm({ ...newVariantForm, packing_price: value });
                        }}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", "E", "@", "#", "!", "$", "%", "*", "(", ")", "^", "&"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pastedText = e.clipboardData.getData("text");
                          if (!/^\d*\.?\d*$/.test(pastedText)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Price (defaults to MRP)"
                      />
                    </div>
                  </div>
                </div>

                {/* Card 5: Shipping Timings & Policy Toggles */}
                <div className="p-3 mb-3" style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #E2E8F0", boxShadow: "0 2px 6px rgba(15, 23, 42, 0.03)" }}>
                  <div className="d-flex align-items-center mb-3" style={{ gap: "8px" }}>
                    <FiTruck style={{ color: "#F97316", fontSize: "16px" }} />
                    <span style={{ fontSize: "13px", fontWeight: 700, color: "#0F172A" }}>Shipping Timings & Policies</span>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Return Window <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.return_window || ""}
                        onChange={(e) => setNewVariantForm({ ...newVariantForm, return_window: e.target.value })}
                        required
                      >
                        <option value="">Select Return Window...</option>
                        <option value="P1D">1 Day (P1D)</option>
                        <option value="P2D">2 Days (P2D)</option>
                        <option value="P3D">3 Days (P3D)</option>
                        <option value="P4D">4 Days (P4D)</option>
                        <option value="P5D">5 Days (P5D)</option>
                        <option value="P6D">6 Days (P6D)</option>
                        <option value="P7D">7 Days (P7D)</option>
                        <option value="P10D">10 Days (P10D)</option>
                        <option value="P15D">15 Days (P15D)</option>
                        <option value="P30D">30 Days (P30D)</option>
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Time To Ship <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.time_to_ship || ""}
                        onChange={(e) => setNewVariantForm({ ...newVariantForm, time_to_ship: e.target.value })}
                        required
                      >
                        <option value="">Select Time To Ship...</option>
                        <option value="P1D">1 Day (P1D)</option>
                        <option value="P2D">2 Days (P2D)</option>
                        <option value="P3D">3 Days (P3D)</option>
                        <option value="P4D">4 Days (P4D)</option>
                        <option value="P5D">5 Days (P5D)</option>
                        <option value="P6D">6 Days (P6D)</option>
                        <option value="P7D">7 Days (P7D)</option>
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Time To Deliver <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.time_to_deliver || ""}
                        onChange={(e) => setNewVariantForm({ ...newVariantForm, time_to_deliver: e.target.value })}
                        required
                      >
                        <option value="">Select Time To Deliver...</option>
                        <option value="P1D">1 Day (P1D)</option>
                        <option value="P2D">2 Days (P2D)</option>
                        <option value="P3D">3 Days (P3D)</option>
                        <option value="P4D">4 Days (P4D)</option>
                        <option value="P5D">5 Days (P5D)</option>
                        <option value="P6D">6 Days (P6D)</option>
                        <option value="P7D">7 Days (P7D)</option>
                        <option value="P10D">10 Days (P10D)</option>
                        <option value="P15D">15 Days (P15D)</option>
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Returnable <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.returnable !== undefined && newVariantForm.returnable !== null && newVariantForm.returnable !== "" ? String(newVariantForm.returnable) : ""}
                        onChange={(e) => setNewVariantForm({ ...newVariantForm, returnable: e.target.value === "true" ? true : (e.target.value === "false" ? false : "") })}
                        required
                      >
                        <option value="">Select Returnable...</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Cancellable <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.cancellable !== undefined && newVariantForm.cancellable !== null && newVariantForm.cancellable !== "" ? String(newVariantForm.cancellable) : ""}
                        onChange={(e) => setNewVariantForm({ ...newVariantForm, cancellable: e.target.value === "true" ? true : (e.target.value === "false" ? false : "") })}
                        required
                      >
                        <option value="">Select Cancellable...</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Replaceable <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.replaceable !== undefined && newVariantForm.replaceable !== null && newVariantForm.replaceable !== "" ? String(newVariantForm.replaceable) : ""}
                        onChange={(e) => setNewVariantForm({ ...newVariantForm, replaceable: e.target.value === "true" ? true : (e.target.value === "false" ? false : "") })}
                        required
                      >
                        <option value="">Select Replaceable...</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Seller Pickup Return <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.seller_pickup_return !== undefined && newVariantForm.seller_pickup_return !== null && newVariantForm.seller_pickup_return !== "" ? String(newVariantForm.seller_pickup_return) : ""}
                        onChange={(e) => setNewVariantForm({ ...newVariantForm, seller_pickup_return: e.target.value === "true" ? true : (e.target.value === "false" ? false : "") })}
                        required
                      >
                        <option value="">Select Seller Pickup Return...</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        COD Allowed <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.cod_allowed !== undefined && newVariantForm.cod_allowed !== null && newVariantForm.cod_allowed !== "" ? String(newVariantForm.cod_allowed) : ""}
                        onChange={(e) => setNewVariantForm({ ...newVariantForm, cod_allowed: e.target.value === "true" ? true : (e.target.value === "false" ? false : "") })}
                        required
                      >
                        <option value="">Select COD Allowed...</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>
                        Active Status <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control form-control-sm"
                        style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                        value={newVariantForm.status !== undefined && newVariantForm.status !== null && newVariantForm.status !== "" ? String(newVariantForm.status) : ""}
                        onChange={(e) => setNewVariantForm({ ...newVariantForm, status: e.target.value === "true" ? true : (e.target.value === "false" ? false : "") })}
                        required
                      >
                        <option value="">Select Status...</option>
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Card 6: Variant Image & Attributes */}
                <div className="p-3 mb-2" style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #E2E8F0", boxShadow: "0 2px 6px rgba(15, 23, 42, 0.03)" }}>
                  <div className="row">
                    <div className="col-md-5 mb-3 mb-md-0">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <label className="form-label font-weight-bold mb-0" style={{ fontSize: "12px", color: "#334155" }}>
                          Variant Images ({Array.isArray(newVariantForm.image) ? newVariantForm.image.length : (newVariantForm.image ? 1 : 0)}/4) <span className="text-danger">*</span>
                        </label>
                        <span style={{ fontSize: "11px", color: "#64748B" }}>Max 4 images</span>
                      </div>
                      <div className="d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
                        {Array.isArray(newVariantForm.image) && newVariantForm.image.length > 0 ? (
                          newVariantForm.image.map((imgUrl, imgIdx) => (
                            <div
                              key={imgIdx}
                              className="p-1 border rounded shadow-sm position-relative"
                              style={{
                                boxSizing: "border-box",
                                width: "78px",
                                height: "78px",
                                backgroundColor: "#ffffff",
                                borderRadius: "10px"
                              }}
                            >
                              <button
                                type="button"
                                style={{
                                  position: "absolute",
                                  top: "-5px",
                                  right: "-5px",
                                  cursor: "pointer",
                                  fontSize: "11px",
                                  backgroundColor: "#EF4444",
                                  color: "#ffffff",
                                  border: "2px solid #ffffff",
                                  borderRadius: "50%",
                                  width: "20px",
                                  height: "20px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: 0,
                                  zIndex: 10,
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                }}
                                onClick={() => handleRemoveVariantImage(imgIdx)}
                                title="Remove Image"
                              >
                                <CloseIcon style={{ fontSize: "11px" }} />
                              </button>
                              <div className="w-100 h-100 d-flex align-items-center justify-content-center overflow-hidden" style={{ borderRadius: "6px" }}>
                                <img
                                  src={imgUrl}
                                  alt={`Variant Preview ${imgIdx + 1}`}
                                  className="w-100 h-100"
                                  style={{ objectFit: "cover" }}
                                />
                              </div>
                            </div>
                          ))
                        ) : null}

                        {(!Array.isArray(newVariantForm.image) || newVariantForm.image.length < 4) && (
                          <div className="file-input-container">
                            <input
                              type="file"
                              id="variant_image_input"
                              accept="image/*"
                              multiple
                              style={{ display: "none" }}
                              onChange={handleVariantImageUpload}
                              disabled={isUploadingVariantImage}
                            />
                            <label
                              htmlFor="variant_image_input"
                              className="d-flex flex-column align-items-center justify-content-center border rounded"
                              style={{
                                width: "78px",
                                height: "78px",
                                cursor: isUploadingVariantImage ? "not-allowed" : "pointer",
                                backgroundColor: "#F8FAFC",
                                borderColor: "#CBD5E1",
                                borderStyle: "dashed",
                                borderWidth: "1.5px",
                                marginBottom: 0,
                                borderRadius: "10px"
                              }}
                            >
                              {isUploadingVariantImage ? (
                                <div className="spinner-border spinner-border-sm text-warning" role="status"></div>
                              ) : (
                                <>
                                  <div>
                                    <BiSolidImageAdd size={24} style={{ color: "#F97316" }} />
                                  </div>
                                  <div>
                                    <span style={{ fontSize: "10.5px", fontWeight: 600, color: "#475569" }}>+ Add Images</span>
                                  </div>
                                </>
                              )}
                            </label>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-7">
                      <label className="form-label font-weight-bold mb-2" style={{ fontSize: "12px", color: "#334155" }}>Variant Attributes</label>
                      {newVariantForm.attributes && newVariantForm.attributes.length > 0 ? (
                        newVariantForm.attributes.map((attr, aIdx) => (
                          <div key={aIdx} className="d-flex align-items-center mb-2" style={{ gap: "8px" }}>
                            <div style={{ flex: 1, position: "relative" }}>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Attribute Name"
                                style={{
                                  borderRadius: "8px",
                                  height: "34px",
                                  backgroundColor: (attr.is_mandatory || attr.product_type_id) ? "#F1F5F9" : "#ffffff",
                                  cursor: (attr.is_mandatory || attr.product_type_id) ? "not-allowed" : "text",
                                  color: (attr.is_mandatory || attr.product_type_id) ? "#0F172A" : undefined,
                                  fontWeight: (attr.is_mandatory || attr.product_type_id) ? 600 : "normal",
                                }}
                                value={attr.attribute_name}
                                readOnly={Boolean(attr.is_mandatory || attr.product_type_id)}
                                onChange={(e) => {
                                  if (attr.is_mandatory || attr.product_type_id) return;
                                  const updated = [...newVariantForm.attributes];
                                  updated[aIdx].attribute_name = e.target.value;
                                  setNewVariantForm({ ...newVariantForm, attributes: updated });
                                }}
                              />
                            </div>
                            <div style={{ flex: 1.5, position: "relative" }}>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder={attr.is_mandatory ? `${attr.attribute_name || "Value"} * (Required)` : "Attribute Value"}
                                style={{ borderRadius: "8px", height: "34px", borderColor: attr.is_mandatory && !attr.attribute_value ? "#EF4444" : undefined }}
                                value={attr.attribute_value}
                                required={attr.is_mandatory}
                                onChange={(e) => {
                                  const updated = [...newVariantForm.attributes];
                                  updated[aIdx].attribute_value = e.target.value;
                                  setNewVariantForm({ ...newVariantForm, attributes: updated });
                                }}
                              />
                            </div>
                            {attr.is_mandatory ? (
                              <span className="badge badge-danger px-2 py-1" style={{ fontSize: "10px", borderRadius: "4px" }}>Required</span>
                            ) : (
                              newVariantForm.attributes.length > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-light text-danger"
                                  onClick={() => {
                                    const updated = [...newVariantForm.attributes];
                                    updated.splice(aIdx, 1);
                                    setNewVariantForm({ ...newVariantForm, attributes: updated });
                                  }}
                                >
                                  ×
                                </button>
                              )
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="p-2 text-center text-muted" style={{ backgroundColor: "#F8FAFC", borderRadius: "8px", fontSize: "12px" }}>
                          No attributes configured for this variant type.
                        </div>
                      )}
                    </div>
                  </div>
                </div>

              </div>

              {/* Footer */}
              <div className="d-flex justify-content-end align-items-center mt-3 pt-3 border-top" style={{ gap: "10px" }}>
                <button
                  type="button"
                  className="btn btn-secondary btn-sm px-4"
                  style={{ borderRadius: "8px", fontWeight: 600, height: "38px" }}
                  onClick={() => setCreateVariantModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn text-white font-weight-bold d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    backgroundColor: "#105293",
                    borderColor: "#105293",
                    borderRadius: "8px",
                    fontWeight: 700,
                    fontSize: "13.5px",
                    height: "38px",
                    minWidth: "150px",
                    gap: "8px"
                  }}
                  disabled={isSubmittingVariant}
                >
                  {isSubmittingVariant ? (
                    <>
                      <Spin size="small" />
                      <span>Saving...</span>
                    </>
                  ) : (
                    <>
                      <FiCheckCircle size={15} />
                      <span>{editingVariantId ? "Update Variation" : "Save Variation"}</span>
                    </>
                  )}
                </button>
              </div>
            </form>
          )}
        </AntModal>

        {/* Product Bulk Update Modal */}
        <Modal
          open={bulkUpdateModalOpen}
          onClose={handleCloseBulkUpdateModal}
          aria-labelledby="bulk-update-modal-title"
          aria-describedby="bulk-update-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 450,
              maxWidth: "92vw",
              bgcolor: "background.paper",
              borderRadius: "14px",
              boxShadow: 24,
              p: 0,
              overflow: "hidden",
            }}
          >
            <div className="modal-content border-0">
              <div
                className="modal-header p-3 d-flex align-items-center justify-content-between border-bottom"
                style={{ backgroundColor: "#F8FAFC" }}
              >
                <h6 className="modal-title m-0" style={{ fontWeight: 700, color: "#0F172A", fontSize: "15px" }}>
                  Bulk Update Products
                </h6>
                <button
                  type="button"
                  className="close border-0 bg-transparent"
                  onClick={handleCloseBulkUpdateModal}
                  style={{ cursor: "pointer", fontSize: "20px", color: "#64748B" }}
                >
                  <CloseIcon />
                </button>
              </div>

              <div className="modal-body p-4">
                <div className="importingSection">
                  <label style={{ fontSize: "13px", fontWeight: 600, color: "#475569", marginBottom: "8px", display: "block" }}>
                    Select CSV / Excel File (.csv, .xlsx, .xls)
                  </label>
                  <input
                    type="file"
                    id="bulkUpdateFileInput"
                    accept=".csv, .xlsx, .xls"
                    className="form-control"
                    style={{ fontSize: "13px", borderRadius: "8px", padding: "6px 10px" }}
                    onChange={(e) => setBulkUpdateFile(e.target.files?.[0] || null)}
                  />
                  {bulkUpdateFile && (
                    <div
                      className="mt-2 text-muted d-flex align-items-center justify-content-between"
                      style={{
                        fontSize: "12px",
                        backgroundColor: "#F1F5F9",
                        padding: "6px 12px",
                        borderRadius: "8px",
                        border: "1px solid #E2E8F0"
                      }}
                    >
                      <div className="text-truncate" style={{ maxWidth: "300px" }}>
                        <i className="fas fa-file-csv mr-1 text-primary"></i>
                        Selected: <strong>{bulkUpdateFile.name}</strong> ({(bulkUpdateFile.size / 1024).toFixed(1)} KB)
                      </div>
                      <button
                        type="button"
                        className="btn btn-sm btn-link text-danger p-0 ml-2"
                        title="Remove / Clear file"
                        style={{ textDecoration: "none", fontSize: "12px", fontWeight: 600 }}
                        onClick={() => {
                          setBulkUpdateFile(null);
                          const input = document.getElementById("bulkUpdateFileInput");
                          if (input) input.value = "";
                        }}
                      >
                        <i className="fas fa-times mr-1"></i> Remove
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-footer p-3 border-top d-flex justify-content-end" style={{ backgroundColor: "#F8FAFC", gap: "8px" }}>
                <button
                  type="button"
                  className="btn btn-sm btn-light border"
                  style={{ borderRadius: "8px", fontWeight: 600, padding: "6px 16px" }}
                  onClick={handleCloseBulkUpdateModal}
                  disabled={isBulkUpdating}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-primary d-inline-flex align-items-center"
                  style={{
                    backgroundColor: "#F97316",
                    borderColor: "#F97316",
                    borderRadius: "8px",
                    fontWeight: 600,
                    padding: "6px 20px",
                    gap: "6px",
                  }}
                  onClick={handleBulkUpdateProducts}
                  disabled={isBulkUpdating || !bulkUpdateFile}
                >
                  {isBulkUpdating && <i className="fas fa-spinner fa-spin"></i>}
                  {isBulkUpdating ? "Updating.." : "Update"}
                </button>
              </div>
            </div>
          </Box>
        </Modal>
      </>
    </ThemeMaker >
  );
};

export default Instorecatalog;
